const plsFootballData = {
    "meta": {
        "total": 1,
            "page": 1,
                "limit": 20,
                    "totalPages": 1,
                        "hasNextPage": false
    },
    "competition": [
        {
            "competition_id": "2kwbbcootiqqgmrzs6o5inle5",
            "profile_id": "football_pls",
            "competition_name": "Premier League",
            "competition_code": "EPL",
            "country": "England",
            "competition_type": "club",
            "competition_data_pull": "",
            "competition_status": ""
        }
    ],
        "season": [
            {
                "season_id": "51r6ph2woavlbbpk8f29nynf8",
                "competition_id": "2kwbbcootiqqgmrzs6o5inle5",
                "season_name": "2025/2026",
                "season_status": "yes"
            }
        ],
            "fixture": [
                {
                    "competition_id": "2kwbbcootiqqgmrzs6o5inle5",
                    "season_id": "51r6ph2woavlbbpk8f29nynf8",
                    "fixture_id": "3toem7hmu4hjjz4oam9n8tf6c",
                    "fixture_status": "Finished",
                    "fixture_round": "",
                    "fixture_date": "2026-02-10Z",
                    "kick_off_time": "19:30:00Z",
                    "venue_id": "3lnmxkrbtsvdffns96nqkggeg",
                    "home_team_id": "9q0arba2kbnywth8bkxlhgmdr",
                    "away_team_id": "48gk2hpqtsl6p9sx9kjhaydq4",
                    "fixture_name": "Chelsea vs Leeds United",
                    "fixture_week": "26",
                    "attendance": "39253",
                    "home_team": [
                        {
                            "competition_id": "2kwbbcootiqqgmrzs6o5inle5",
                            "team_id": "9q0arba2kbnywth8bkxlhgmdr",
                            "season_id": "51r6ph2woavlbbpk8f29nynf8",
                            "team_name": "Chelsea FC",
                            "team_short_name": "Chelsea",
                            "team_tricode": "CHE",
                            "away_shirt_colour_1": "#f9f9f9",
                            "away_shorts_colour_1": "#f9f9f9",
                            "away_socks_colour_1": "#2e3434",
                            "home_shirt_colour_1": "#1520bc",
                            "home_shorts_colour_1": "#1520bc",
                            "home_socks_colour_1": "#ffffff",
                            "third_shirt_colour_1": "#000000",
                            "third_shorts_colour_1": "#000000",
                            "third_socks_colour_1": "#000000",
                            "stats": [
                                {
                                    "type": "offtargetAttAssist",
                                    "value": "7"
                                },
                                {
                                    "type": "goalsIbox",
                                    "value": "2"
                                },
                                {
                                    "type": "interception",
                                    "value": "7"
                                },
                                {
                                    "type": "headClearance",
                                    "value": "13"
                                },
                                {
                                    "type": "keeperThrows",
                                    "value": "5"
                                },
                                {
                                    "type": "interceptionWon",
                                    "value": "7"
                                },
                                {
                                    "type": "longPassOwnToOppSuccess",
                                    "value": "42"
                                },
                                {
                                    "type": "leftsidePass",
                                    "value": "196"
                                },
                                {
                                    "type": "longPassOwnToOpp",
                                    "value": "62"
                                },
                                {
                                    "type": "lostCorners",
                                    "value": "1"
                                },
                                {
                                    "type": "midfielderGoals",
                                    "value": "1"
                                },
                                {
                                    "type": "goodHighClaim",
                                    "value": "1"
                                },
                                {
                                    "type": "ontargetAttAssist",
                                    "value": "9"
                                },
                                {
                                    "type": "ontargetScoringAtt",
                                    "value": "4"
                                },
                                {
                                    "type": "openPlayPass",
                                    "value": "625"
                                },
                                {
                                    "type": "ppda",
                                    "value": "14.8"
                                },
                                {
                                    "type": "outfielderBlock",
                                    "value": "2"
                                },
                                {
                                    "type": "penaltyFaced",
                                    "value": "1"
                                },
                                {
                                    "type": "oppositionPasses",
                                    "value": "282"
                                },
                                {
                                    "type": "penAreaEntries",
                                    "value": "34"
                                },
                                {
                                    "type": "possLostAll",
                                    "value": "99"
                                },
                                {
                                    "type": "fwdPass",
                                    "value": "143"
                                },
                                {
                                    "type": "attOneOnOne",
                                    "value": "1"
                                },
                                {
                                    "type": "attRfTotal",
                                    "value": "7"
                                },
                                {
                                    "type": "firstHalfGoals",
                                    "value": "1"
                                },
                                {
                                    "type": "fkFoulLost",
                                    "value": "9"
                                },
                                {
                                    "type": "effectiveHeadClearance",
                                    "value": "13"
                                },
                                {
                                    "type": "finalThirdEntries",
                                    "value": "54"
                                },
                                {
                                    "type": "forwardGoals",
                                    "value": "1"
                                },
                                {
                                    "type": "fkFoulWon",
                                    "value": "13"
                                },
                                {
                                    "type": "fouledFinalThird",
                                    "value": "4"
                                },
                                {
                                    "type": "passesRight",
                                    "value": "54"
                                },
                                {
                                    "type": "freekickCross",
                                    "value": "1"
                                },
                                {
                                    "type": "goals",
                                    "value": "2"
                                },
                                {
                                    "type": "goalAssistOpenplay",
                                    "value": "1"
                                },
                                {
                                    "type": "goalAssistIntentional",
                                    "value": "1"
                                },
                                {
                                    "type": "goalAssist",
                                    "value": "1"
                                },
                                {
                                    "type": "goalKicks",
                                    "value": "2"
                                },
                                {
                                    "type": "goalsOpenplay",
                                    "value": "1"
                                },
                                {
                                    "type": "goalsConceded",
                                    "value": "2"
                                },
                                {
                                    "type": "goalsConcededIbox",
                                    "value": "2"
                                },
                                {
                                    "type": "totalThroughBall",
                                    "value": "12"
                                },
                                {
                                    "type": "totalLongBalls",
                                    "value": "34"
                                },
                                {
                                    "type": "totalLayoffs",
                                    "value": "18"
                                },
                                {
                                    "type": "totalAttAssist",
                                    "value": "16"
                                },
                                {
                                    "type": "successfulFinalThirdPasses",
                                    "value": "123"
                                },
                                {
                                    "type": "totalBackZonePass",
                                    "value": "344"
                                },
                                {
                                    "type": "totalHighClaim",
                                    "value": "1"
                                },
                                {
                                    "type": "totalScoringAtt",
                                    "value": "19"
                                },
                                {
                                    "type": "totalPass",
                                    "value": "644"
                                },
                                {
                                    "type": "totalTackle",
                                    "value": "14"
                                },
                                {
                                    "type": "totalThrows",
                                    "value": "20"
                                },
                                {
                                    "type": "totalContest",
                                    "value": "11"
                                },
                                {
                                    "type": "touches",
                                    "value": "832"
                                },
                                {
                                    "type": "totalYellowCard",
                                    "value": "4"
                                },
                                {
                                    "type": "touchesInFinalThird",
                                    "value": "188"
                                },
                                {
                                    "type": "wonCorners",
                                    "value": "4"
                                },
                                {
                                    "type": "wonTackle",
                                    "value": "6"
                                },
                                {
                                    "type": "formationUsed",
                                    "value": "4231"
                                },
                                {
                                    "type": "unsuccessfulTouch",
                                    "value": "20"
                                },
                                {
                                    "type": "touchesInOppBox",
                                    "value": "34"
                                },
                                {
                                    "type": "wonContest",
                                    "value": "5"
                                },
                                {
                                    "type": "subsMade",
                                    "value": "4"
                                },
                                {
                                    "type": "passesLeft",
                                    "value": "46"
                                },
                                {
                                    "type": "penaltyWon",
                                    "value": "1"
                                },
                                {
                                    "type": "penGoalsConceded",
                                    "value": "1"
                                },
                                {
                                    "type": "possWonAtt3rd",
                                    "value": "1"
                                },
                                {
                                    "type": "ptsDroppedWinningPos",
                                    "value": "2"
                                },
                                {
                                    "type": "possWonDef3rd",
                                    "value": "11"
                                },
                                {
                                    "type": "shotOffTarget",
                                    "value": "8"
                                },
                                {
                                    "type": "progressiveCarries",
                                    "value": "69"
                                },
                                {
                                    "type": "rightsidePass",
                                    "value": "206"
                                },
                                {
                                    "type": "attOpenplay",
                                    "value": "11"
                                },
                                {
                                    "type": "sixYardBlock",
                                    "value": "1"
                                },
                                {
                                    "type": "totalCrossNocorner",
                                    "value": "16"
                                },
                                {
                                    "type": "successfulPutThrough",
                                    "value": "6"
                                },
                                {
                                    "type": "totalFwdZonePass",
                                    "value": "319"
                                },
                                {
                                    "type": "totalCross",
                                    "value": "19"
                                },
                                {
                                    "type": "totalFinalThirdPasses",
                                    "value": "158"
                                },
                                {
                                    "type": "totalOffside",
                                    "value": "4"
                                },
                                {
                                    "type": "totalFlickOn",
                                    "value": "5"
                                },
                                {
                                    "type": "totalLaunches",
                                    "value": "11"
                                },
                                {
                                    "type": "possWonMid3rd",
                                    "value": "19"
                                },
                                {
                                    "type": "attBxLeft",
                                    "value": "1"
                                },
                                {
                                    "type": "attAssistOpenplay",
                                    "value": "14"
                                },
                                {
                                    "type": "attCmissRight",
                                    "value": "1"
                                },
                                {
                                    "type": "attAssistSetplay",
                                    "value": "1"
                                },
                                {
                                    "type": "attCorner",
                                    "value": "5"
                                },
                                {
                                    "type": "attGoalHighCentre",
                                    "value": "1"
                                },
                                {
                                    "type": "attFreekickTotal",
                                    "value": "1"
                                },
                                {
                                    "type": "attFreekickTarget",
                                    "value": "1"
                                },
                                {
                                    "type": "attGoalLowRight",
                                    "value": "1"
                                },
                                {
                                    "type": "possessionPercentage",
                                    "value": "65.8"
                                },
                                {
                                    "type": "attCmissHigh",
                                    "value": "1"
                                },
                                {
                                    "type": "possLostCtrl",
                                    "value": "99"
                                },
                                {
                                    "type": "totalClearance",
                                    "value": "22"
                                },
                                {
                                    "type": "totalCornersIntobox",
                                    "value": "3"
                                },
                                {
                                    "type": "attHdMiss",
                                    "value": "2"
                                },
                                {
                                    "type": "successfulOpenPlayPass",
                                    "value": "575"
                                },
                                {
                                    "type": "penaltyConceded",
                                    "value": "1"
                                },
                                {
                                    "type": "putThrough",
                                    "value": "11"
                                },
                                {
                                    "type": "attHdTotal",
                                    "value": "3"
                                },
                                {
                                    "type": "totalChippedPass",
                                    "value": "24"
                                },
                                {
                                    "type": "aerialWon",
                                    "value": "14"
                                },
                                {
                                    "type": "accurateCross",
                                    "value": "6"
                                },
                                {
                                    "type": "accurateGoalKicks",
                                    "value": "2"
                                },
                                {
                                    "type": "accurateLongBalls",
                                    "value": "18"
                                },
                                {
                                    "type": "accurateBackZonePass",
                                    "value": "333"
                                },
                                {
                                    "type": "accurateCornersIntobox",
                                    "value": "1"
                                },
                                {
                                    "type": "accurateLayoffs",
                                    "value": "15"
                                },
                                {
                                    "type": "accurateFwdZonePass",
                                    "value": "266"
                                },
                                {
                                    "type": "accuratePass",
                                    "value": "593"
                                },
                                {
                                    "type": "accurateThroughBall",
                                    "value": "4"
                                },
                                {
                                    "type": "attIboxBlocked",
                                    "value": "5"
                                },
                                {
                                    "type": "accurateKeeperThrows",
                                    "value": "5"
                                },
                                {
                                    "type": "accurateLaunches",
                                    "value": "5"
                                },
                                {
                                    "type": "accurateCrossNocorner",
                                    "value": "5"
                                },
                                {
                                    "type": "accurateFlickOn",
                                    "value": "2"
                                },
                                {
                                    "type": "aerialLost",
                                    "value": "17"
                                },
                                {
                                    "type": "accurateChippedPass",
                                    "value": "13"
                                },
                                {
                                    "type": "attBxCentre",
                                    "value": "9"
                                },
                                {
                                    "type": "attCmissLeft",
                                    "value": "1"
                                },
                                {
                                    "type": "attBxRight",
                                    "value": "1"
                                },
                                {
                                    "type": "carries",
                                    "value": "138"
                                },
                                {
                                    "type": "duelLost",
                                    "value": "38"
                                },
                                {
                                    "type": "challengeLost",
                                    "value": "2"
                                },
                                {
                                    "type": "blockedPass",
                                    "value": "6"
                                },
                                {
                                    "type": "duelWon",
                                    "value": "46"
                                },
                                {
                                    "type": "attSetpiece",
                                    "value": "1"
                                },
                                {
                                    "type": "bigChanceCreated",
                                    "value": "4"
                                },
                                {
                                    "type": "attOboxTarget",
                                    "value": "2"
                                },
                                {
                                    "type": "bigChanceMissed",
                                    "value": "3"
                                },
                                {
                                    "type": "attemptsConcededIbox",
                                    "value": "2"
                                },
                                {
                                    "type": "ballRecovery",
                                    "value": "36"
                                },
                                {
                                    "type": "backwardPass",
                                    "value": "99"
                                },
                                {
                                    "type": "attSvLowLeft",
                                    "value": "1"
                                },
                                {
                                    "type": "attemptsIbox",
                                    "value": "14"
                                },
                                {
                                    "type": "effectiveClearance",
                                    "value": "22"
                                },
                                {
                                    "type": "attOboxMiss",
                                    "value": "1"
                                },
                                {
                                    "type": "attObxCentre",
                                    "value": "5"
                                },
                                {
                                    "type": "attSvLowCentre",
                                    "value": "1"
                                },
                                {
                                    "type": "errorLeadToGoal",
                                    "value": "1"
                                },
                                {
                                    "type": "attRfTarget",
                                    "value": "1"
                                },
                                {
                                    "type": "attPenGoal",
                                    "value": "1"
                                },
                                {
                                    "type": "attemptsConcededObox",
                                    "value": "2"
                                },
                                {
                                    "type": "attLfGoal",
                                    "value": "2"
                                },
                                {
                                    "type": "attIboxGoal",
                                    "value": "2"
                                },
                                {
                                    "type": "attLfTarget",
                                    "value": "1"
                                },
                                {
                                    "type": "attIboxMiss",
                                    "value": "7"
                                },
                                {
                                    "type": "attLfTotal",
                                    "value": "9"
                                },
                                {
                                    "type": "attMissHigh",
                                    "value": "3"
                                },
                                {
                                    "type": "cornerTaken",
                                    "value": "4"
                                },
                                {
                                    "type": "blockedScoringAtt",
                                    "value": "7"
                                },
                                {
                                    "type": "attemptsObox",
                                    "value": "5"
                                },
                                {
                                    "type": "accurateThrows",
                                    "value": "20"
                                },
                                {
                                    "type": "crosses18yard",
                                    "value": "8"
                                },
                                {
                                    "type": "attMissLeft",
                                    "value": "2"
                                },
                                {
                                    "type": "attOboxBlocked",
                                    "value": "2"
                                },
                                {
                                    "type": "crosses18yardplus",
                                    "value": "7"
                                },
                                {
                                    "type": "dispossessed",
                                    "value": "5"
                                },
                                {
                                    "type": "attemptedTackleFoul",
                                    "value": "4"
                                },
                                {
                                    "type": "bigChanceScored",
                                    "value": "2"
                                },
                                {
                                    "type": "attMissRight",
                                    "value": "3"
                                },
                                {
                                    "type": "defensiveActions",
                                    "value": "19"
                                },
                                {
                                    "type": "expectedGoals",
                                    "value": "1.83"
                                }
                            ],
                            "lineup": [
                                {
                                    "lineup_id": "2bfs1dfmyao4e3gzha29t1lw4",
                                    "role": "Player",
                                    "player_position": "Attacking Midfielder",
                                    "player_position_side": "Attacking Midfielder",
                                    "formation": "442",
                                    "is_captain": null,
                                    "formation_place": 21,
                                    "staff_role": null,
                                    "patched": {
                                        "formation": true,
                                        "formation_place": true,
                                        "player_position": true,
                                        "player_position_side": true
                                    }
                                },
                                {
                                    "lineup_id": "5jk0wq14a8emikh2vh53aw0ve",
                                    "role": "Player",
                                    "player_position": "Striker",
                                    "player_position_side": "Defensive Midfielder",
                                    "formation": "442",
                                    "is_captain": null,
                                    "formation_place": 5,
                                    "staff_role": null,
                                    "patched": {
                                        "formation": true,
                                        "player_position": true,
                                        "player_position_side": true,
                                        "formation_place": true
                                    }
                                },
                                {
                                    "lineup_id": "eaqqezw2ed1u0tt3zc128mr1m",
                                    "role": "Player",
                                    "player_position": "Substitute",
                                    "player_position_side": null,
                                    "formation": "442",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null,
                                    "patched": {
                                        "formation_place": true,
                                        "player_position_side": true,
                                        "player_position": true,
                                        "formation": true
                                    }
                                },
                                {
                                    "lineup_id": "4gsw40604vgil5nvu4t6uzgus",
                                    "role": "Player",
                                    "player_position": "Striker",
                                    "player_position_side": "Striker",
                                    "formation": "442",
                                    "is_captain": null,
                                    "formation_place": 9,
                                    "staff_role": null,
                                    "patched": {
                                        "formation_place": true,
                                        "is_captain": true,
                                        "lineup_id": true,
                                        "player_position": true,
                                        "player_position_side": true,
                                        "staff_role": true,
                                        "formation": true
                                    }
                                },
                                {
                                    "lineup_id": "ay8tikc1j1r2luqovxrmuf9xw",
                                    "role": "Player",
                                    "player_position": "Striker",
                                    "player_position_side": "Striker",
                                    "formation": "442",
                                    "is_captain": null,
                                    "formation_place": 15,
                                    "staff_role": null,
                                    "patched": {
                                        "formation": true,
                                        "formation_place": true,
                                        "is_captain": true,
                                        "lineup_id": true,
                                        "player_position": true,
                                        "player_position_side": true,
                                        "staff_role": true
                                    }
                                },
                                {
                                    "lineup_id": "dczrgxyolp7lcz413wkz7ap61",
                                    "role": "Player",
                                    "player_position": "Defensive Midfielder",
                                    "player_position_side": "Defensive Midfielder",
                                    "formation": "442",
                                    "is_captain": null,
                                    "formation_place": 5,
                                    "staff_role": null,
                                    "patched": {
                                        "formation_place": true,
                                        "is_captain": true,
                                        "lineup_id": true,
                                        "player_position": true,
                                        "player_position_side": true,
                                        "staff_role": true,
                                        "formation": true
                                    }
                                },
                                {
                                    "lineup_id": "dl10343h8yopcgerzur5samwa",
                                    "role": "Player",
                                    "player_position": "Striker",
                                    "player_position_side": "Goalkeeper",
                                    "formation": "442",
                                    "is_captain": null,
                                    "formation_place": 11,
                                    "staff_role": null,
                                    "patched": {
                                        "formation_place": true,
                                        "player_position_side": true,
                                        "player_position": true,
                                        "formation": true
                                    }
                                },
                                {
                                    "lineup_id": "8jt4vsixxoqp4uvskyfl7k222",
                                    "role": "Player",
                                    "player_position": "Striker",
                                    "player_position_side": "Defensive Midfielder",
                                    "formation": "442",
                                    "is_captain": null,
                                    "formation_place": 13,
                                    "staff_role": null,
                                    "patched": {
                                        "formation_place": true,
                                        "player_position": true,
                                        "player_position_side": true,
                                        "formation": true
                                    }
                                },
                                {
                                    "lineup_id": "7yirx71oya71zjsgldj5ucqcq",
                                    "role": "Player",
                                    "player_position": "Substitute",
                                    "player_position_side": null,
                                    "formation": "442",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null,
                                    "patched": {
                                        "formation": true
                                    }
                                },
                                {
                                    "lineup_id": "bgydmtsi0ngn9k56apo29v0no",
                                    "role": "Player",
                                    "player_position": "Substitute",
                                    "player_position_side": null,
                                    "formation": "442",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null,
                                    "patched": {
                                        "formation": true
                                    }
                                },
                                {
                                    "lineup_id": "9vk04uj215dfan7wak7j25hjo",
                                    "role": "Player",
                                    "player_position": "Substitute",
                                    "player_position_side": null,
                                    "formation": "442",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null,
                                    "patched": {
                                        "formation": true
                                    }
                                },
                                {
                                    "lineup_id": "5jk0wq14a8emikh2vh53aw0ve",
                                    "role": null,
                                    "player_position": null,
                                    "player_position_side": null,
                                    "formation": "442",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null,
                                    "patched": {
                                        "formation": true
                                    }
                                },
                                {
                                    "lineup_id": "eaqqezw2ed1u0tt3zc128mr1m",
                                    "role": null,
                                    "player_position": null,
                                    "player_position_side": null,
                                    "formation": "442",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null,
                                    "patched": {
                                        "formation": true
                                    }
                                },
                                {
                                    "lineup_id": "2hb3k34yedp2vi7ok6umajutx",
                                    "role": "Staff",
                                    "player_position": "Goalkeeper",
                                    "player_position_side": "Centre",
                                    "formation": "442",
                                    "is_captain": null,
                                    "formation_place": "1",
                                    "staff_role": "manager",
                                    "patched": {
                                        "formation": true
                                    }
                                },
                                {
                                    "lineup_id": "d9yxninyn4bac8f0ufxsnlqll",
                                    "role": "Player",
                                    "player_position": "Striker",
                                    "player_position_side": "Attacking Midfielder",
                                    "formation": "442",
                                    "is_captain": null,
                                    "formation_place": 17,
                                    "staff_role": null,
                                    "patched": {
                                        "formation_place": true,
                                        "player_position_side": true,
                                        "player_position": true,
                                        "formation": true
                                    }
                                },
                                {
                                    "lineup_id": "dgthbtwjv3s2sbeq32844eqne",
                                    "role": "Player",
                                    "player_position": "Substitute",
                                    "player_position_side": null,
                                    "formation": "442",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null,
                                    "patched": {
                                        "formation": true
                                    }
                                },
                                {
                                    "lineup_id": "6psklvi66inwws7buzf16yjft",
                                    "role": "Player",
                                    "player_position": "Substitute",
                                    "player_position_side": null,
                                    "formation": "442",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null,
                                    "patched": {
                                        "formation": true
                                    }
                                },
                                {
                                    "lineup_id": "e5eiuko5p1yms97xndrvcr0bu",
                                    "role": "Player",
                                    "player_position": "Substitute",
                                    "player_position_side": null,
                                    "formation": "442",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null,
                                    "patched": {
                                        "formation": true
                                    }
                                },
                                {
                                    "lineup_id": "5g5wwp5luxo1rz1kp6chvz0x6",
                                    "role": "Player",
                                    "player_position": "Substitute",
                                    "player_position_side": null,
                                    "formation": "442",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null,
                                    "patched": {
                                        "formation": true
                                    }
                                },
                                {
                                    "lineup_id": "dl10343h8yopcgerzur5samwa",
                                    "role": null,
                                    "player_position": null,
                                    "player_position_side": null,
                                    "formation": "442",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null,
                                    "patched": {
                                        "formation": true
                                    }
                                },
                                {
                                    "lineup_id": "8ezfdv6lgv4gz8kogxvvn1rtg",
                                    "role": "Player",
                                    "player_position": "Defensive Midfielder",
                                    "player_position_side": "Defensive Midfielder",
                                    "formation": "442",
                                    "is_captain": null,
                                    "formation_place": 1,
                                    "staff_role": null,
                                    "patched": {
                                        "formation_place": true,
                                        "player_position_side": true,
                                        "player_position": true,
                                        "formation": true
                                    }
                                },
                                {
                                    "lineup_id": "39ccv9t7ydrrcwd1es1xu2e50",
                                    "role": null,
                                    "player_position": null,
                                    "player_position_side": null,
                                    "formation": "442",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null,
                                    "patched": {
                                        "formation": true
                                    }
                                },
                                {
                                    "lineup_id": "1zxwich342p8fholev7ddkwh6",
                                    "role": "Player",
                                    "player_position": "Defender",
                                    "player_position_side": "Attacking Midfielder",
                                    "formation": "442",
                                    "is_captain": "yes",
                                    "formation_place": 11,
                                    "staff_role": null,
                                    "patched": {
                                        "formation_place": true,
                                        "player_position_side": true,
                                        "player_position": true,
                                        "formation": true
                                    }
                                },
                                {
                                    "lineup_id": "3uc9z96xvain84leorf4ls962",
                                    "role": "Player",
                                    "player_position": "Striker",
                                    "player_position_side": "Centre",
                                    "formation": "442",
                                    "is_captain": null,
                                    "formation_place": 11,
                                    "staff_role": null,
                                    "patched": {
                                        "formation_place": true,
                                        "player_position_side": true,
                                        "player_position": true,
                                        "formation": true
                                    }
                                },
                                {
                                    "lineup_id": "ek4oa7zejocbbgu1l2vdebitw",
                                    "role": "Player",
                                    "player_position": "Attacking Midfielder",
                                    "player_position_side": "Defender",
                                    "formation": "442",
                                    "is_captain": null,
                                    "formation_place": 9,
                                    "staff_role": null,
                                    "patched": {
                                        "formation_place": true,
                                        "player_position": true,
                                        "player_position_side": true,
                                        "formation": true
                                    }
                                },
                                {
                                    "lineup_id": "5e2zgfe3ltc6qbnoqdfshqsph",
                                    "role": "Player",
                                    "player_position": "Defender",
                                    "player_position_side": "Defender",
                                    "formation": "442",
                                    "is_captain": null,
                                    "formation_place": 19,
                                    "staff_role": null,
                                    "patched": {
                                        "formation_place": true,
                                        "player_position_side": true,
                                        "player_position": true,
                                        "formation": true
                                    }
                                },
                                {
                                    "lineup_id": "8jt4vsixxoqp4uvskyfl7k222",
                                    "role": null,
                                    "player_position": null,
                                    "player_position_side": null,
                                    "formation": "3421",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null,
                                    "patched": {
                                        "formation": true
                                    }
                                },
                                {
                                    "lineup_id": "7c2wnewpcf1idj6ghj6gu0wyd",
                                    "role": "Player",
                                    "player_position": "Substitute",
                                    "player_position_side": null,
                                    "formation": "442",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null,
                                    "patched": {
                                        "formation_place": true,
                                        "player_position_side": true,
                                        "player_position": true,
                                        "formation": true
                                    }
                                }
                            ],
                            "player": [
                                {
                                    "player_id": "dczrgxyolp7lcz413wkz7ap61",
                                    "player_first_name": "Reece Lewis",
                                    "player_last_name": "James",
                                    "player_short_name": "Reece",
                                    "player_dob": "1999-12-08",
                                    "player_birth_place": "London",
                                    "shirt_number": 24,
                                    "player_position": "Defender",
                                    "stats": []
                                },
                                {
                                    "player_id": "9vk04uj215dfan7wak7j25hjo",
                                    "player_first_name": "Marc",
                                    "player_last_name": "Guiu Paz",
                                    "player_short_name": "Marc",
                                    "player_dob": "2006-01-04",
                                    "player_birth_place": "Granollers",
                                    "shirt_number": 38,
                                    "player_position": "Attacker",
                                    "stats": []
                                },
                                {
                                    "player_id": "a8mpq72gjzwvwdkooe0hv41zo",
                                    "player_first_name": "Alfie",
                                    "player_last_name": "Gilchrist",
                                    "player_short_name": "Alfie",
                                    "player_dob": "2003-11-28",
                                    "player_birth_place": null,
                                    "shirt_number": null,
                                    "player_position": "Defender",
                                    "stats": []
                                },
                                {
                                    "player_id": "amcwh6w0brmkttg4uc5qm6z9w",
                                    "player_first_name": "Nicolas",
                                    "player_last_name": "Jackson",
                                    "player_short_name": "Nicolas",
                                    "player_dob": "2001-06-20",
                                    "player_birth_place": "Banjul",
                                    "shirt_number": 15,
                                    "player_position": "Attacker",
                                    "stats": []
                                },
                                {
                                    "player_id": "ax29zmnwn0agsspjjqs0as50q",
                                    "player_first_name": "Gabriel Paweł",
                                    "player_last_name": "Słonina",
                                    "player_short_name": "Gaga",
                                    "player_dob": "2004-05-15",
                                    "player_birth_place": "Addison",
                                    "shirt_number": 44,
                                    "player_position": "Goalkeeper",
                                    "stats": []
                                },
                                {
                                    "player_id": "ay02byqc6zdrh5xy3d4fy5qay",
                                    "player_first_name": "Mykhailo",
                                    "player_last_name": "Mudryk",
                                    "player_short_name": "Mykhailo",
                                    "player_dob": "2001-01-05",
                                    "player_birth_place": "Krasnohrad",
                                    "shirt_number": null,
                                    "player_position": "Midfielder",
                                    "stats": []
                                },
                                {
                                    "player_id": "ay8tikc1j1r2luqovxrmuf9xw",
                                    "player_first_name": "Aaron",
                                    "player_last_name": "Anselmino",
                                    "player_short_name": "Aaron",
                                    "player_dob": "2005-04-29",
                                    "player_birth_place": "Bernardo Larroudé",
                                    "shirt_number": 30,
                                    "player_position": "Defender",
                                    "stats": []
                                },
                                {
                                    "player_id": "bfdtduknquzhr2br7ahlgvvo4",
                                    "player_first_name": "Renato",
                                    "player_last_name": "Palma Veiga",
                                    "player_short_name": "Renato",
                                    "player_dob": "2003-07-29",
                                    "player_birth_place": "Lisboa",
                                    "shirt_number": null,
                                    "player_position": "Midfielder",
                                    "stats": []
                                },
                                {
                                    "player_id": "bgydmtsi0ngn9k56apo29v0no",
                                    "player_first_name": "Jorrel Evan",
                                    "player_last_name": "Hato",
                                    "player_short_name": "Jorrel",
                                    "player_dob": "2006-03-07",
                                    "player_birth_place": "Rotterdam",
                                    "shirt_number": 21,
                                    "player_position": "Defender",
                                    "stats": []
                                },
                                {
                                    "player_id": "c0nk7lwd19tv9y3cl9bomrkes",
                                    "player_first_name": "Deivid Washington",
                                    "player_last_name": "de Souza Eugênio",
                                    "player_short_name": "Deivid Washington",
                                    "player_dob": "2005-06-05",
                                    "player_birth_place": "Itumbiara",
                                    "shirt_number": null,
                                    "player_position": "Attacker",
                                    "stats": []
                                },
                                {
                                    "player_id": "c2mwg1uhug0pbgl72uf9b927e",
                                    "player_first_name": "Jamie Jermaine",
                                    "player_last_name": "Bynoe-Gittens",
                                    "player_short_name": "Jamie",
                                    "player_dob": "2004-08-08",
                                    "player_birth_place": "London",
                                    "shirt_number": 11,
                                    "player_position": "Attacker",
                                    "stats": []
                                },
                                {
                                    "player_id": "c5dl4ijc192leqtjd8a2g14pg",
                                    "player_first_name": "Max Andrew",
                                    "player_last_name": "Merrick",
                                    "player_short_name": "Max",
                                    "player_dob": "2005-11-10",
                                    "player_birth_place": "High Wycombe",
                                    "shirt_number": 50,
                                    "player_position": "Goalkeeper",
                                    "stats": []
                                },
                                {
                                    "player_id": "d9l1cw2cz19goqdt39fzw01zo",
                                    "player_first_name": "Calum",
                                    "player_last_name": "McFarlane",
                                    "player_short_name": "Calum",
                                    "player_dob": "1985-11-13",
                                    "player_birth_place": null,
                                    "shirt_number": null,
                                    "player_position": null,
                                    "stats": []
                                },
                                {
                                    "player_id": "d9yxninyn4bac8f0ufxsnlqll",
                                    "player_first_name": "Robert test",
                                    "player_last_name": "Lynch Sánchez",
                                    "player_short_name": "Robert",
                                    "player_dob": "1997-11-18",
                                    "player_birth_place": "Cartagena",
                                    "shirt_number": 1,
                                    "player_position": "Goalkeeper",
                                    "patched": {
                                        "player_first_name": true,
                                        "patched": true,
                                        "isPatched": true
                                    },
                                    "stats": []
                                },
                                {
                                    "player_id": "9drh3w3emxjf6aah8pstsdgr8",
                                    "player_first_name": "Facundo Valentín",
                                    "player_last_name": "Buonanotte",
                                    "player_short_name": "Facundo",
                                    "player_dob": "2004-12-23",
                                    "player_birth_place": "Pérez",
                                    "shirt_number": 40,
                                    "player_position": "Midfielder",
                                    "stats": []
                                },
                                {
                                    "player_id": "dgjl6ks0r7lbh09fe8cuwj7ro",
                                    "player_first_name": "Roméo",
                                    "player_last_name": "Lavia",
                                    "player_short_name": "Roméo",
                                    "player_dob": "2004-01-06",
                                    "player_birth_place": "Brussels",
                                    "shirt_number": 45,
                                    "player_position": "Midfielder",
                                    "stats": []
                                },
                                {
                                    "player_id": "dgthbtwjv3s2sbeq32844eqne",
                                    "player_first_name": "Teddy Samuel",
                                    "player_last_name": "Sharman-Lowe",
                                    "player_short_name": "Teddy",
                                    "player_dob": "2003-03-30",
                                    "player_birth_place": "Leicester",
                                    "shirt_number": 28,
                                    "player_position": "Goalkeeper",
                                    "stats": []
                                },
                                {
                                    "player_id": "dl10343h8yopcgerzur5samwa",
                                    "player_first_name": "Cole Jermaine",
                                    "player_last_name": "Palmer",
                                    "player_short_name": "Cole",
                                    "player_dob": "2002-05-06",
                                    "player_birth_place": "Manchester",
                                    "shirt_number": 10,
                                    "player_position": "Midfielder",
                                    "stats": []
                                },
                                {
                                    "player_id": "e5eiuko5p1yms97xndrvcr0bu",
                                    "player_first_name": "Alejandro",
                                    "player_last_name": "Garnacho Ferreyra",
                                    "player_short_name": "Alejandro",
                                    "player_dob": "2004-07-01",
                                    "player_birth_place": "Madrid",
                                    "shirt_number": 49,
                                    "player_position": "Attacker",
                                    "stats": []
                                },
                                {
                                    "player_id": "e9l5r0txzrjbenli05rn3k4wl",
                                    "player_first_name": "Raheem Shaquille",
                                    "player_last_name": "Sterling",
                                    "player_short_name": "Raheem",
                                    "player_dob": "1994-12-08",
                                    "player_birth_place": "Kingston",
                                    "shirt_number": null,
                                    "player_position": "Attacker",
                                    "stats": []
                                },
                                {
                                    "player_id": "eaqqezw2ed1u0tt3zc128mr1m",
                                    "player_first_name": "João Pedro",
                                    "player_last_name": "Junqueira de Jesus",
                                    "player_short_name": "João Pedro",
                                    "player_dob": "2001-09-26",
                                    "player_birth_place": "Ribeirão Preto",
                                    "shirt_number": 20,
                                    "player_position": "Attacker",
                                    "stats": []
                                },
                                {
                                    "player_id": "eiqcjlj9kmitoj8g50vaglawa",
                                    "player_first_name": "Filip",
                                    "player_last_name": "Jörgensen",
                                    "player_short_name": "Filip",
                                    "player_dob": "2002-04-16",
                                    "player_birth_place": "Lomma",
                                    "shirt_number": 12,
                                    "player_position": "Goalkeeper",
                                    "stats": []
                                },
                                {
                                    "player_id": "ek4oa7zejocbbgu1l2vdebitw",
                                    "player_first_name": "Joshua Kofi",
                                    "player_last_name": "Acheampong",
                                    "player_short_name": "Josh",
                                    "player_dob": "2006-05-05",
                                    "player_birth_place": "London",
                                    "shirt_number": 34,
                                    "player_position": "Defender",
                                    "stats": []
                                },
                                {
                                    "player_id": "el8asgbjqbtvu9dcpyv9d668k",
                                    "player_first_name": "Reggie Spencer",
                                    "player_last_name": "Walsh",
                                    "player_short_name": "Reggie",
                                    "player_dob": "2008-10-20",
                                    "player_birth_place": null,
                                    "shirt_number": 46,
                                    "player_position": "Midfielder",
                                    "stats": []
                                },
                                {
                                    "player_id": "es8orzwchom47yjt6nwwuc5qs",
                                    "player_first_name": "Tyrique Aaron Delali Yusuff",
                                    "player_last_name": "George",
                                    "player_short_name": "Tyrique",
                                    "player_dob": "2006-02-04",
                                    "player_birth_place": "London",
                                    "shirt_number": 32,
                                    "player_position": "Attacker",
                                    "stats": []
                                },
                                {
                                    "player_id": "3djmsd2atvq16ysmocq7twsfd",
                                    "player_first_name": "Axel Wilson Arthur",
                                    "player_last_name": "Disasi Mhakinis Belho",
                                    "player_short_name": "Axel",
                                    "player_dob": "1998-03-11",
                                    "player_birth_place": "Gonesse",
                                    "shirt_number": null,
                                    "player_position": "Defender",
                                    "stats": []
                                },
                                {
                                    "player_id": "2bfs1dfmyao4e3gzha29t1lw4",
                                    "player_first_name": "Mamadou",
                                    "player_last_name": "Sarr",
                                    "player_short_name": "Mamadou",
                                    "player_dob": "2005-08-29",
                                    "player_birth_place": "Martigues",
                                    "shirt_number": 19,
                                    "player_position": "Defender",
                                    "stats": []
                                },
                                {
                                    "player_id": "cjllsuu49urbg6otxfz4ov5lg",
                                    "player_first_name": "Charlie",
                                    "player_last_name": "Holland",
                                    "player_short_name": "Charlie",
                                    "player_dob": "2009-07-03",
                                    "player_birth_place": null,
                                    "shirt_number": 75,
                                    "player_position": "Midfielder",
                                    "stats": []
                                },
                                {
                                    "player_id": "5e2zgfe3ltc6qbnoqdfshqsph",
                                    "player_first_name": "Trevoh Tom",
                                    "player_last_name": "Chalobah",
                                    "player_short_name": "Trevoh",
                                    "player_dob": "1999-07-05",
                                    "player_birth_place": "Freetown",
                                    "shirt_number": 23,
                                    "player_position": "Defender",
                                    "stats": []
                                },
                                {
                                    "player_id": "7usl4495egoptlrd762f0arbp",
                                    "player_first_name": "Benjamin James",
                                    "player_last_name": "Chilwell",
                                    "player_short_name": "Ben",
                                    "player_dob": "1996-12-21",
                                    "player_birth_place": "Milton Keynes",
                                    "shirt_number": null,
                                    "player_position": "Defender",
                                    "stats": []
                                },
                                {
                                    "player_id": "1aadm4iglakwo8i0t2aq14q38",
                                    "player_first_name": "Shumaira Zion",
                                    "player_last_name": "Mheuka",
                                    "player_short_name": "Shumaira",
                                    "player_dob": "2007-10-20",
                                    "player_birth_place": "Birmingham",
                                    "shirt_number": 62,
                                    "player_position": "Attacker",
                                    "stats": []
                                },
                                {
                                    "player_id": "1g8xr073jl9jwmh5yrco855d6",
                                    "player_first_name": "Dário",
                                    "player_last_name": "Cassia Luís Essugo",
                                    "player_short_name": "Dário",
                                    "player_dob": "2005-03-14",
                                    "player_birth_place": "Lisboa",
                                    "shirt_number": 14,
                                    "player_position": "Midfielder",
                                    "stats": []
                                },
                                {
                                    "player_id": "1j0a3ml1zglc9s31yentfckb9",
                                    "player_first_name": "Christopher Alan",
                                    "player_last_name": "Nkunku",
                                    "player_short_name": "Christopher",
                                    "player_dob": "1997-11-14",
                                    "player_birth_place": "Lagny-sur-Marne",
                                    "shirt_number": 18,
                                    "player_position": "Attacker",
                                    "stats": []
                                },
                                {
                                    "player_id": "1uafbcsmi3tjrkau2tp7awkk4",
                                    "player_first_name": "Landon Cruz Buzi",
                                    "player_last_name": "Emenalo",
                                    "player_short_name": "Landon",
                                    "player_dob": "2008-01-18",
                                    "player_birth_place": null,
                                    "shirt_number": 56,
                                    "player_position": "Midfielder",
                                    "stats": []
                                },
                                {
                                    "player_id": "1zxwich342p8fholev7ddkwh6",
                                    "player_first_name": "Enzo Jeremías",
                                    "player_last_name": "Fernández",
                                    "player_short_name": "Enzo",
                                    "player_dob": "2001-01-17",
                                    "player_birth_place": "San Martín",
                                    "shirt_number": 8,
                                    "player_position": "Midfielder",
                                    "stats": []
                                },
                                {
                                    "player_id": "2hb3k34yedp2vi7ok6umajutx",
                                    "player_first_name": "Liam James",
                                    "player_last_name": "Rosenior",
                                    "player_short_name": "Liam",
                                    "player_dob": "1984-07-09",
                                    "player_birth_place": "London",
                                    "shirt_number": null,
                                    "player_position": null,
                                    "stats": []
                                },
                                {
                                    "player_id": "2p6uagebunshlw5zmp16748dm",
                                    "player_first_name": "Caleb Ryan",
                                    "player_last_name": "Wiley",
                                    "player_short_name": "Caleb",
                                    "player_dob": "2004-12-22",
                                    "player_birth_place": "Atlanta",
                                    "shirt_number": null,
                                    "player_position": "Defender",
                                    "stats": []
                                },
                                {
                                    "player_id": "39ccv9t7ydrrcwd1es1xu2e50",
                                    "player_first_name": "Andrey test",
                                    "player_last_name": "Nascimento dos Santos",
                                    "player_short_name": "Andrey",
                                    "player_dob": "2004-05-03",
                                    "player_birth_place": "Rio de Janeiro",
                                    "shirt_number": 17,
                                    "player_position": "Midfielder",
                                    "patched": {
                                        "player_short_name": true,
                                        "is_captain": true,
                                        "player_first_name": true
                                    },
                                    "stats": []
                                },
                                {
                                    "player_id": "3uc9z96xvain84leorf4ls962",
                                    "player_first_name": "Moisés Isaac",
                                    "player_last_name": "Caicedo Corozo",
                                    "player_short_name": "Moisés",
                                    "player_dob": "2001-11-02",
                                    "player_birth_place": "Santo Domingo",
                                    "shirt_number": 25,
                                    "player_position": "Midfielder",
                                    "stats": []
                                },
                                {
                                    "player_id": "433fwn94e2najnmvvg9u47oyc",
                                    "player_first_name": "Ishé Barrington",
                                    "player_last_name": "Samuels-Smith",
                                    "player_short_name": "Ishé",
                                    "player_dob": "2006-06-05",
                                    "player_birth_place": "Manchester",
                                    "shirt_number": null,
                                    "player_position": "Defender",
                                    "stats": []
                                },
                                {
                                    "player_id": "4gsw40604vgil5nvu4t6uzgus",
                                    "player_first_name": "Ted Noah",
                                    "player_last_name": "Curd",
                                    "player_short_name": "Ted",
                                    "player_dob": "2006-02-14",
                                    "player_birth_place": "London",
                                    "shirt_number": 35,
                                    "player_position": "Goalkeeper",
                                    "stats": []
                                },
                                {
                                    "player_id": "573hlc6devy50gjotyav9ql4a",
                                    "player_first_name": "Levi Lamar",
                                    "player_last_name": "Samuels Colwill",
                                    "player_short_name": "Levi",
                                    "player_dob": "2003-02-26",
                                    "player_birth_place": "Southampton",
                                    "shirt_number": 6,
                                    "player_position": "Defender",
                                    "stats": []
                                },
                                {
                                    "player_id": "4zgia9osqxtlscs1fnjm1zg0l",
                                    "player_first_name": "Vincenzo",
                                    "player_last_name": "Maresca",
                                    "player_short_name": "Enzo",
                                    "player_dob": "1980-02-10",
                                    "player_birth_place": "Pontecagnano Faiano",
                                    "shirt_number": null,
                                    "player_position": null,
                                    "stats": []
                                },
                                {
                                    "player_id": "5g5wwp5luxo1rz1kp6chvz0x6",
                                    "player_first_name": "Benoît",
                                    "player_last_name": "Ntambue Badiashile Mukinayi Baya",
                                    "player_short_name": "Benoît",
                                    "player_dob": "2001-03-26",
                                    "player_birth_place": "Limoges",
                                    "shirt_number": 5,
                                    "player_position": "Defender",
                                    "stats": []
                                },
                                {
                                    "player_id": "5jk0wq14a8emikh2vh53aw0ve",
                                    "player_first_name": "Liam Rory test",
                                    "player_last_name": "Delap ",
                                    "player_short_name": "Liam",
                                    "player_dob": "2003-02-08",
                                    "player_birth_place": "Winchester",
                                    "shirt_number": 9,
                                    "player_position": "Attacker",
                                    "patched": {
                                        "player_last_name": true,
                                        "player_first_name": true,
                                        "lineup_id": true
                                    },
                                    "stats": []
                                },
                                {
                                    "player_id": "5ql70wwevaoqpxabylew5f696",
                                    "player_first_name": "Carney Chibueze",
                                    "player_last_name": "Chukwuemeka",
                                    "player_short_name": "Carney",
                                    "player_dob": "2003-10-20",
                                    "player_birth_place": "Eisenstadt",
                                    "shirt_number": null,
                                    "player_position": "Midfielder",
                                    "stats": []
                                },
                                {
                                    "player_id": "5wtu1k4ol5j037tvwgqiwvlec",
                                    "player_first_name": "Ollie",
                                    "player_last_name": "Harrison",
                                    "player_short_name": "Ollie",
                                    "player_dob": "2007-08-07",
                                    "player_birth_place": null,
                                    "shirt_number": 58,
                                    "player_position": "Midfielder",
                                    "stats": []
                                },
                                {
                                    "player_id": "661b6x35l9b9uieqbcq7el1hx",
                                    "player_first_name": "Abdul-Nasir Oluwatosin Oluwadoyinsolami",
                                    "player_last_name": "Adarabioyo",
                                    "player_short_name": "Tosin",
                                    "player_dob": "1997-09-24",
                                    "player_birth_place": "London",
                                    "shirt_number": 4,
                                    "player_position": "Defender",
                                    "stats": []
                                },
                                {
                                    "player_id": "6bhm9cfkwxv5ojh49rqv11g45",
                                    "player_first_name": "Wilfredo Daniel",
                                    "player_last_name": "Caballero Lazcano",
                                    "player_short_name": "Willy",
                                    "player_dob": "1981-09-28",
                                    "player_birth_place": "Santa Elena",
                                    "shirt_number": null,
                                    "player_position": null,
                                    "stats": []
                                },
                                {
                                    "player_id": "6ita8t40qk3b85mrqpq71gjys",
                                    "player_first_name": "David Datro",
                                    "player_last_name": "Fofana",
                                    "player_short_name": "David Datro",
                                    "player_dob": "2002-12-22",
                                    "player_birth_place": "Ouragahio",
                                    "shirt_number": null,
                                    "player_position": "Attacker",
                                    "stats": []
                                },
                                {
                                    "player_id": "6psklvi66inwws7buzf16yjft",
                                    "player_first_name": "Pedro",
                                    "player_last_name": "Lomba Neto",
                                    "player_short_name": "Pedro",
                                    "player_dob": "2000-03-09",
                                    "player_birth_place": "Viana do Castelo",
                                    "shirt_number": 7,
                                    "player_position": "Attacker",
                                    "stats": []
                                },
                                {
                                    "player_id": "7c2wnewpcf1idj6ghj6gu0wyd",
                                    "player_first_name": "Marc",
                                    "player_last_name": "Cucurella Saseta",
                                    "player_short_name": "Marc",
                                    "player_dob": "1998-07-22",
                                    "player_birth_place": "Alella",
                                    "shirt_number": 3,
                                    "player_position": "Defender",
                                    "stats": []
                                },
                                {
                                    "player_id": "7qy8by5ysig5af425m7tl4aac",
                                    "player_first_name": "Ryan",
                                    "player_last_name": "Kavuma-McQueen",
                                    "player_short_name": "Ryan",
                                    "player_dob": "2009-01-01",
                                    "player_birth_place": null,
                                    "shirt_number": 76,
                                    "player_position": "Attacker",
                                    "stats": []
                                },
                                {
                                    "player_id": "7yirx71oya71zjsgldj5ucqcq",
                                    "player_first_name": "Wesley Tidjan",
                                    "player_last_name": "Fofana",
                                    "player_short_name": "Wesley",
                                    "player_dob": "2000-12-17",
                                    "player_birth_place": "Marseille",
                                    "shirt_number": 29,
                                    "player_position": "Defender",
                                    "stats": []
                                },
                                {
                                    "player_id": "8ezfdv6lgv4gz8kogxvvn1rtg",
                                    "player_first_name": "Estêvão Willian",
                                    "player_last_name": "Almeida de Oliveira Gonçalves",
                                    "player_short_name": "Estêvão Willian",
                                    "player_dob": "2007-04-24",
                                    "player_birth_place": "Franca",
                                    "shirt_number": 41,
                                    "player_position": "Attacker",
                                    "stats": []
                                },
                                {
                                    "player_id": "8jt4vsixxoqp4uvskyfl7k222",
                                    "player_first_name": "Malo Arthur",
                                    "player_last_name": "Gusto",
                                    "player_short_name": "Malo",
                                    "player_dob": "2003-05-19",
                                    "player_birth_place": "Décines-Charpieu",
                                    "shirt_number": 27,
                                    "player_position": "Defender",
                                    "stats": []
                                }
                            ],
                            "staff": [
                                {
                                    "staff_id": "2hb3k34yedp2vi7ok6umajutx",
                                    "staff_first_name": "Liam James",
                                    "staff_last_name": "Rosenior",
                                    "staff_short_first_name": "Liam",
                                    "staff_short_last_name": "Rosenior",
                                    "staff_title": "manager"
                                },
                                {
                                    "staff_id": "d9l1cw2cz19goqdt39fzw01zo",
                                    "staff_first_name": "Calum",
                                    "staff_last_name": "McFarlane",
                                    "staff_short_first_name": "Calum",
                                    "staff_short_last_name": "McFarlane",
                                    "staff_title": "manager"
                                },
                                {
                                    "staff_id": "4zgia9osqxtlscs1fnjm1zg0l",
                                    "staff_first_name": "Vincenzo",
                                    "staff_last_name": "Maresca",
                                    "staff_short_first_name": "Enzo",
                                    "staff_short_last_name": "Maresca",
                                    "staff_title": "manager"
                                },
                                {
                                    "staff_id": "6bhm9cfkwxv5ojh49rqv11g45",
                                    "staff_first_name": "Wilfredo Daniel",
                                    "staff_last_name": "Caballero Lazcano",
                                    "staff_short_first_name": "Willy",
                                    "staff_short_last_name": "Caballero",
                                    "staff_title": "manager"
                                }
                            ],
                            "fixture_team_setting": [
                                {
                                    "kit_type": "CHE_H",
                                    "patched": {
                                        "kit_type": true
                                    }
                                }
                            ]
                        }
                    ],
                    "away_team": [
                        {
                            "competition_id": "2kwbbcootiqqgmrzs6o5inle5",
                            "team_id": "48gk2hpqtsl6p9sx9kjhaydq4",
                            "season_id": "51r6ph2woavlbbpk8f29nynf8",
                            "team_name": "Leeds United",
                            "team_short_name": "Leeds",
                            "team_tricode": "LEE",
                            "away_shirt_colour_1": "#113ce8",
                            "away_shirt_colour_2": "#eacc07",
                            "away_shorts_colour_1": "#113ce8",
                            "away_socks_colour_1": "#113ce8",
                            "home_shirt_colour_1": "#ffffff",
                            "home_shorts_colour_1": "#ffffff",
                            "home_socks_colour_1": "#ffffff",
                            "third_shirt_colour_1": "#191f43",
                            "third_shirt_colour_2": "#3b7dc6",
                            "third_shorts_colour_1": "#191f43",
                            "third_socks_colour_1": "#191f43",
                            "stats": [
                                {
                                    "type": "successfulFinalThirdPasses",
                                    "value": "45"
                                },
                                {
                                    "type": "leftsidePass",
                                    "value": "93"
                                },
                                {
                                    "type": "passesRight",
                                    "value": "45"
                                },
                                {
                                    "type": "interceptionsInBox",
                                    "value": "1"
                                },
                                {
                                    "type": "putThrough",
                                    "value": "11"
                                },
                                {
                                    "type": "progressiveCarries",
                                    "value": "22"
                                },
                                {
                                    "type": "rightsidePass",
                                    "value": "78"
                                },
                                {
                                    "type": "savedObox",
                                    "value": "2"
                                },
                                {
                                    "type": "saves",
                                    "value": "2"
                                },
                                {
                                    "type": "ontargetScoringAtt",
                                    "value": "2"
                                },
                                {
                                    "type": "interceptionWon",
                                    "value": "9"
                                },
                                {
                                    "type": "longPassOwnToOppSuccess",
                                    "value": "28"
                                },
                                {
                                    "type": "possWonMid3rd",
                                    "value": "8"
                                },
                                {
                                    "type": "punches",
                                    "value": "1"
                                },
                                {
                                    "type": "ptsGainedLosingPos",
                                    "value": "1"
                                },
                                {
                                    "type": "possessionPercentage",
                                    "value": "34.2"
                                },
                                {
                                    "type": "totalBackZonePass",
                                    "value": "185"
                                },
                                {
                                    "type": "subsMade",
                                    "value": "3"
                                },
                                {
                                    "type": "goals",
                                    "value": "2"
                                },
                                {
                                    "type": "possWonDef3rd",
                                    "value": "12"
                                },
                                {
                                    "type": "goalsIbox",
                                    "value": "2"
                                },
                                {
                                    "type": "goalsConcededIbox",
                                    "value": "2"
                                },
                                {
                                    "type": "goalsOpenplay",
                                    "value": "1"
                                },
                                {
                                    "type": "goalsConceded",
                                    "value": "2"
                                },
                                {
                                    "type": "interception",
                                    "value": "9"
                                },
                                {
                                    "type": "headClearance",
                                    "value": "17"
                                },
                                {
                                    "type": "passesLeft",
                                    "value": "23"
                                },
                                {
                                    "type": "totalClearance",
                                    "value": "33"
                                },
                                {
                                    "type": "overrun",
                                    "value": "2"
                                },
                                {
                                    "type": "lostCorners",
                                    "value": "4"
                                },
                                {
                                    "type": "ontargetAttAssist",
                                    "value": "2"
                                },
                                {
                                    "type": "goalAssist",
                                    "value": "1"
                                },
                                {
                                    "type": "goalAssistIntentional",
                                    "value": "1"
                                },
                                {
                                    "type": "longPassOwnToOpp",
                                    "value": "55"
                                },
                                {
                                    "type": "outfielderBlock",
                                    "value": "7"
                                },
                                {
                                    "type": "oppositionPasses",
                                    "value": "480"
                                },
                                {
                                    "type": "totalYellowCard",
                                    "value": "4"
                                },
                                {
                                    "type": "totalLongBalls",
                                    "value": "52"
                                },
                                {
                                    "type": "ppda",
                                    "value": "25.3"
                                },
                                {
                                    "type": "openPlayPass",
                                    "value": "308"
                                },
                                {
                                    "type": "totalThrows",
                                    "value": "17"
                                },
                                {
                                    "type": "lastManTackle",
                                    "value": "1"
                                },
                                {
                                    "type": "keeperThrows",
                                    "value": "7"
                                },
                                {
                                    "type": "totalScoringAtt",
                                    "value": "4"
                                },
                                {
                                    "type": "totalPullBack",
                                    "value": "1"
                                },
                                {
                                    "type": "successfulPutThrough",
                                    "value": "5"
                                },
                                {
                                    "type": "totalPass",
                                    "value": "336"
                                },
                                {
                                    "type": "touches",
                                    "value": "504"
                                },
                                {
                                    "type": "touchesInFinalThird",
                                    "value": "95"
                                },
                                {
                                    "type": "unsuccessfulTouch",
                                    "value": "20"
                                },
                                {
                                    "type": "formationUsed",
                                    "value": "541"
                                },
                                {
                                    "type": "wonContest",
                                    "value": "2"
                                },
                                {
                                    "type": "wonCorners",
                                    "value": "1"
                                },
                                {
                                    "type": "wonTackle",
                                    "value": "6"
                                },
                                {
                                    "type": "totalFlickOn",
                                    "value": "2"
                                },
                                {
                                    "type": "totalChippedPass",
                                    "value": "25"
                                },
                                {
                                    "type": "totalContest",
                                    "value": "4"
                                },
                                {
                                    "type": "totalCornersIntobox",
                                    "value": "1"
                                },
                                {
                                    "type": "totalCross",
                                    "value": "4"
                                },
                                {
                                    "type": "totalFinalThirdPasses",
                                    "value": "74"
                                },
                                {
                                    "type": "totalCrossNocorner",
                                    "value": "3"
                                },
                                {
                                    "type": "totalFwdZonePass",
                                    "value": "155"
                                },
                                {
                                    "type": "touchesInOppBox",
                                    "value": "17"
                                },
                                {
                                    "type": "possWonAtt3rd",
                                    "value": "1"
                                },
                                {
                                    "type": "successfulOpenPlayPass",
                                    "value": "256"
                                },
                                {
                                    "type": "totalAttAssist",
                                    "value": "2"
                                },
                                {
                                    "type": "totalLaunches",
                                    "value": "18"
                                },
                                {
                                    "type": "totalOffside",
                                    "value": "1"
                                },
                                {
                                    "type": "totalLayoffs",
                                    "value": "7"
                                },
                                {
                                    "type": "totalTackle",
                                    "value": "11"
                                },
                                {
                                    "type": "subsGoals",
                                    "value": "1"
                                },
                                {
                                    "type": "attemptsObox",
                                    "value": "2"
                                },
                                {
                                    "type": "attLfTotal",
                                    "value": "1"
                                },
                                {
                                    "type": "attOboxBlocked",
                                    "value": "2"
                                },
                                {
                                    "type": "attObxCentre",
                                    "value": "2"
                                },
                                {
                                    "type": "attLfGoal",
                                    "value": "1"
                                },
                                {
                                    "type": "attGoalLowLeft",
                                    "value": "1"
                                },
                                {
                                    "type": "attIboxGoal",
                                    "value": "2"
                                },
                                {
                                    "type": "attGoalLowCentre",
                                    "value": "1"
                                },
                                {
                                    "type": "attHdTotal",
                                    "value": "1"
                                },
                                {
                                    "type": "attOpenplay",
                                    "value": "2"
                                },
                                {
                                    "type": "attemptsIbox",
                                    "value": "2"
                                },
                                {
                                    "type": "backwardPass",
                                    "value": "60"
                                },
                                {
                                    "type": "attRfTotal",
                                    "value": "2"
                                },
                                {
                                    "type": "attemptedTackleFoul",
                                    "value": "7"
                                },
                                {
                                    "type": "attRfGoal",
                                    "value": "1"
                                },
                                {
                                    "type": "attemptsConcededObox",
                                    "value": "5"
                                },
                                {
                                    "type": "attPenGoal",
                                    "value": "1"
                                },
                                {
                                    "type": "attSetpiece",
                                    "value": "1"
                                },
                                {
                                    "type": "attBxCentre",
                                    "value": "2"
                                },
                                {
                                    "type": "accurateChippedPass",
                                    "value": "19"
                                },
                                {
                                    "type": "accurateCross",
                                    "value": "1"
                                },
                                {
                                    "type": "accurateBackZonePass",
                                    "value": "170"
                                },
                                {
                                    "type": "accurateLongBalls",
                                    "value": "21"
                                },
                                {
                                    "type": "accuratePass",
                                    "value": "274"
                                },
                                {
                                    "type": "aerialLost",
                                    "value": "14"
                                },
                                {
                                    "type": "attAssistSetplay",
                                    "value": "1"
                                },
                                {
                                    "type": "accurateThrows",
                                    "value": "11"
                                },
                                {
                                    "type": "attemptsConcededIbox",
                                    "value": "14"
                                },
                                {
                                    "type": "accurateLayoffs",
                                    "value": "6"
                                },
                                {
                                    "type": "aerialWon",
                                    "value": "17"
                                },
                                {
                                    "type": "accurateKeeperThrows",
                                    "value": "7"
                                },
                                {
                                    "type": "accurateFwdZonePass",
                                    "value": "105"
                                },
                                {
                                    "type": "accurateGoalKicks",
                                    "value": "5"
                                },
                                {
                                    "type": "accurateLaunches",
                                    "value": "2"
                                },
                                {
                                    "type": "accurateFreekickCross",
                                    "value": "1"
                                },
                                {
                                    "type": "goalAssistOpenplay",
                                    "value": "1"
                                },
                                {
                                    "type": "errorLeadToShot",
                                    "value": "1"
                                },
                                {
                                    "type": "finalThirdEntries",
                                    "value": "40"
                                },
                                {
                                    "type": "effectiveClearance",
                                    "value": "33"
                                },
                                {
                                    "type": "forwardGoals",
                                    "value": "1"
                                },
                                {
                                    "type": "fkFoulWon",
                                    "value": "9"
                                },
                                {
                                    "type": "fouledFinalThird",
                                    "value": "2"
                                },
                                {
                                    "type": "freekickCross",
                                    "value": "2"
                                },
                                {
                                    "type": "fwdPass",
                                    "value": "105"
                                },
                                {
                                    "type": "effectiveHeadClearance",
                                    "value": "17"
                                },
                                {
                                    "type": "goalKicks",
                                    "value": "14"
                                },
                                {
                                    "type": "penAreaEntries",
                                    "value": "12"
                                },
                                {
                                    "type": "penGoalsConceded",
                                    "value": "1"
                                },
                                {
                                    "type": "penaltyConceded",
                                    "value": "1"
                                },
                                {
                                    "type": "penaltyFaced",
                                    "value": "1"
                                },
                                {
                                    "type": "penaltyWon",
                                    "value": "1"
                                },
                                {
                                    "type": "possLostAll",
                                    "value": "108"
                                },
                                {
                                    "type": "possLostCtrl",
                                    "value": "108"
                                },
                                {
                                    "type": "ballRecovery",
                                    "value": "30"
                                },
                                {
                                    "type": "duelLost",
                                    "value": "46"
                                },
                                {
                                    "type": "blockedPass",
                                    "value": "5"
                                },
                                {
                                    "type": "defensiveActions",
                                    "value": "19"
                                },
                                {
                                    "type": "expectedGoals",
                                    "value": "0.74"
                                },
                                {
                                    "type": "carries",
                                    "value": "42"
                                },
                                {
                                    "type": "cornerTaken",
                                    "value": "1"
                                },
                                {
                                    "type": "dispossessed",
                                    "value": "12"
                                },
                                {
                                    "type": "crosses18yardplus",
                                    "value": "1"
                                },
                                {
                                    "type": "challengeLost",
                                    "value": "5"
                                },
                                {
                                    "type": "accurateCrossNocorner",
                                    "value": "1"
                                },
                                {
                                    "type": "blockedScoringAtt",
                                    "value": "2"
                                },
                                {
                                    "type": "bigChanceScored",
                                    "value": "2"
                                },
                                {
                                    "type": "blockedCross",
                                    "value": "1"
                                },
                                {
                                    "type": "bigChanceCreated",
                                    "value": "1"
                                },
                                {
                                    "type": "duelWon",
                                    "value": "38"
                                },
                                {
                                    "type": "effectiveBlockedCross",
                                    "value": "1"
                                },
                                {
                                    "type": "fkFoulLost",
                                    "value": "13"
                                }
                            ],
                            "lineup": [
                                {
                                    "role": "Player",
                                    "lineup_id": "eaqqezw2ed1u0tt3zc128mr1m",
                                    "player_position": null,
                                    "player_position_side": null,
                                    "formation": "352",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "374kcix9j7e1cob4uxmfncwyd",
                                    "player_position": "Midfielder",
                                    "player_position_side": "Midfielder",
                                    "formation": null,
                                    "is_captain": null,
                                    "formation_place": 19,
                                    "staff_role": null,
                                    "patched": {
                                        "player_position": true,
                                        "player_position_side": true,
                                        "formation_place": true
                                    }
                                },
                                {
                                    "role": "Staff",
                                    "lineup_id": "2hb3k34yedp2vi7ok6umajutx",
                                    "player_position": null,
                                    "player_position_side": null,
                                    "formation": "352",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "3uc9z96xvain84leorf4ls962",
                                    "player_position": null,
                                    "player_position_side": null,
                                    "formation": "352",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "7c2wnewpcf1idj6ghj6gu0wyd",
                                    "player_position": null,
                                    "player_position_side": null,
                                    "formation": "352",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "dgthbtwjv3s2sbeq32844eqne",
                                    "player_position": null,
                                    "player_position_side": null,
                                    "formation": "352",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "9vk04uj215dfan7wak7j25hjo",
                                    "player_position": null,
                                    "player_position_side": null,
                                    "formation": "352",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "1zxwich342p8fholev7ddkwh6",
                                    "player_position": null,
                                    "player_position_side": null,
                                    "formation": "352",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "7yirx71oya71zjsgldj5ucqcq",
                                    "player_position": null,
                                    "player_position_side": null,
                                    "formation": "352",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "8jt4vsixxoqp4uvskyfl7k222",
                                    "player_position": null,
                                    "player_position_side": null,
                                    "formation": "352",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "ek4oa7zejocbbgu1l2vdebitw",
                                    "player_position": null,
                                    "player_position_side": null,
                                    "formation": "352",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "8ezfdv6lgv4gz8kogxvvn1rtg",
                                    "player_position": null,
                                    "player_position_side": null,
                                    "formation": "352",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "374kcix9j7e1cob4uxmfncwyd",
                                    "player_position": "Midfielder",
                                    "player_position_side": "Midfielder",
                                    "formation": "541",
                                    "is_captain": null,
                                    "formation_place": 21,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "5e2zgfe3ltc6qbnoqdfshqsph",
                                    "player_position": null,
                                    "player_position_side": null,
                                    "formation": "352",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "5g5wwp5luxo1rz1kp6chvz0x6",
                                    "player_position": null,
                                    "player_position_side": null,
                                    "formation": "352",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "dl10343h8yopcgerzur5samwa",
                                    "player_position": null,
                                    "player_position_side": null,
                                    "formation": "352",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "5jk0wq14a8emikh2vh53aw0ve",
                                    "player_position": null,
                                    "player_position_side": null,
                                    "formation": "352",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "d9yxninyn4bac8f0ufxsnlqll",
                                    "player_position": null,
                                    "player_position_side": null,
                                    "formation": "352",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "2bfs1dfmyao4e3gzha29t1lw4",
                                    "player_position": null,
                                    "player_position_side": null,
                                    "formation": "352",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "e5eiuko5p1yms97xndrvcr0bu",
                                    "player_position": null,
                                    "player_position_side": null,
                                    "formation": "352",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "39ccv9t7ydrrcwd1es1xu2e50",
                                    "player_position": null,
                                    "player_position_side": null,
                                    "formation": "352",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "bgydmtsi0ngn9k56apo29v0no",
                                    "player_position": null,
                                    "player_position_side": null,
                                    "formation": "352",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "6psklvi66inwws7buzf16yjft",
                                    "player_position": null,
                                    "player_position_side": null,
                                    "formation": "352",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "6icypdqtfk2k81ax0i49j5xpl",
                                    "player_position": "Substitute",
                                    "player_position_side": null,
                                    "formation": "541",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "fr9ac60188vlmtbrcddhxii1",
                                    "player_position": "Midfielder",
                                    "player_position_side": "Midfielder",
                                    "formation": "541",
                                    "is_captain": null,
                                    "formation_place": 15,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "dve7yj8usejn9x7pmdjvozje1",
                                    "player_position": "Substitute",
                                    "player_position_side": null,
                                    "formation": "541",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "9z2j13bl5yh4i1vyofautc9yi",
                                    "player_position": "Substitute",
                                    "player_position_side": null,
                                    "formation": "541",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "9drh3w3emxjf6aah8pstsdgr8",
                                    "player_position": "Substitute",
                                    "player_position_side": null,
                                    "formation": "541",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "9kvp5ddeay1cmfwoao8eo1vbp",
                                    "player_position": "Substitute",
                                    "player_position_side": null,
                                    "formation": "541",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "f1ma05bi3t1hfbflylx5d9tyh",
                                    "player_position": "Midfielder",
                                    "player_position_side": "Midfielder",
                                    "formation": "541",
                                    "is_captain": "yes",
                                    "formation_place": 21,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "embn1jhcly07i6pjcvcdiavo5",
                                    "player_position": "Midfielder",
                                    "player_position_side": "Midfielder",
                                    "formation": "541",
                                    "is_captain": null,
                                    "formation_place": 7,
                                    "staff_role": null,
                                    "patched": {
                                        "formation_place": true,
                                        "player_position": true,
                                        "player_position_side": true
                                    }
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "fij46jr9fq43444gr1y8tl9l",
                                    "player_position": "Goalkeeper",
                                    "player_position_side": "Defender",
                                    "formation": "541",
                                    "is_captain": null,
                                    "formation_place": 1,
                                    "staff_role": null,
                                    "patched": {
                                        "formation_place": true,
                                        "player_position_side": true,
                                        "player_position": true
                                    }
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "ah0f7tonnst92d8q91j1wll62",
                                    "player_position": "Midfielder",
                                    "player_position_side": "Wing Back",
                                    "formation": "541",
                                    "is_captain": null,
                                    "formation_place": 3,
                                    "staff_role": null,
                                    "patched": {
                                        "formation_place": true,
                                        "player_position_side": true,
                                        "player_position": true
                                    }
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "otan631zzfnq2sektkl3ywo9",
                                    "player_position": "Defender",
                                    "player_position_side": "Defender",
                                    "formation": "541",
                                    "is_captain": null,
                                    "formation_place": 17,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "dr0kn3srxtg7nuw99gjoim7e1",
                                    "player_position": "Striker",
                                    "player_position_side": "Striker",
                                    "formation": "541",
                                    "is_captain": null,
                                    "formation_place": 11,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "cnoomjxp6tna0mx2ycuptgixh",
                                    "player_position": "Wing Back",
                                    "player_position_side": "Wing Back",
                                    "formation": "541",
                                    "is_captain": null,
                                    "formation_place": 9,
                                    "staff_role": null,
                                    "patched": {
                                        "formation_place": true,
                                        "player_position": true,
                                        "player_position_side": true
                                    }
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "9pv566tidfz21e00y4t0mbap5",
                                    "player_position": "Substitute",
                                    "player_position_side": null,
                                    "formation": "541",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "dkwkmrmpb7rq4e660efcu5hat",
                                    "player_position": "Substitute",
                                    "player_position_side": null,
                                    "formation": "541",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "dwumn5qew7ae53givnx2p892h",
                                    "player_position": "Goalkeeper",
                                    "player_position_side": "Defender",
                                    "formation": "541",
                                    "is_captain": null,
                                    "formation_place": 5,
                                    "staff_role": null,
                                    "patched": {
                                        "formation_place": true,
                                        "player_position": true,
                                        "player_position_side": true
                                    }
                                },
                                {
                                    "role": "Staff",
                                    "lineup_id": "djo99px7j95m6hzrod3l7yk0l",
                                    "player_position": "Goalkeeper",
                                    "player_position_side": "Centre",
                                    "formation": "541",
                                    "is_captain": null,
                                    "formation_place": "1",
                                    "staff_role": "manager"
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "aqlu9i7yzmnmyzwuw6u93j6y1",
                                    "player_position": "Substitute",
                                    "player_position_side": null,
                                    "formation": "541",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "6ka58mn83rknx80e4y2jk3949",
                                    "player_position": "Substitute",
                                    "player_position_side": null,
                                    "formation": "541",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "8rrcscn29rs1gk8mi1pwpu92i",
                                    "player_position": "Defender",
                                    "player_position_side": "Defender",
                                    "formation": "541",
                                    "is_captain": null,
                                    "formation_place": 13,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "28ucbvor6b0yxreoieehudfc9",
                                    "player_position": "Substitute",
                                    "player_position_side": null,
                                    "formation": "541",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "b275i2lg3anqae5lv9gmrzmqx",
                                    "player_position": "Substitute",
                                    "player_position_side": null,
                                    "formation": "541",
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                },
                                {
                                    "role": "Player",
                                    "lineup_id": "b275i2lg3anqae5lv9gmrzmqx",
                                    "player_position": "Substitute",
                                    "player_position_side": null,
                                    "formation": null,
                                    "is_captain": null,
                                    "formation_place": null,
                                    "staff_role": null
                                }
                            ],
                            "player": [
                                {
                                    "player_id": "dve7yj8usejn9x7pmdjvozje1",
                                    "player_first_name": "Lucas",
                                    "player_last_name": "Estella Perri",
                                    "player_short_name": "Lucas Estella",
                                    "player_dob": "1997-12-10",
                                    "player_birth_place": "Campinas",
                                    "shirt_number": 1,
                                    "player_position": "Goalkeeper",
                                    "stats": []
                                },
                                {
                                    "player_id": "az7owi5t4bclkamjsjuyxzv1l",
                                    "player_first_name": "Anton Levi",
                                    "player_last_name": "Stach",
                                    "player_short_name": "Anton",
                                    "player_dob": "1998-11-15",
                                    "player_birth_place": "Buchholz in der Nordheide",
                                    "shirt_number": 18,
                                    "player_position": "Midfielder",
                                    "stats": []
                                },
                                {
                                    "player_id": "b275i2lg3anqae5lv9gmrzmqx",
                                    "player_first_name": "Pascal Augustus",
                                    "player_last_name": "Struijk",
                                    "player_short_name": "Pascal",
                                    "player_dob": "1999-08-11",
                                    "player_birth_place": null,
                                    "shirt_number": 5,
                                    "player_position": "Defender",
                                    "stats": []
                                },
                                {
                                    "player_id": "bhh4rxan5u73tq3qdlkwxpb84",
                                    "player_first_name": "Charles David",
                                    "player_last_name": "Crew",
                                    "player_short_name": "Charlie",
                                    "player_dob": "2006-06-15",
                                    "player_birth_place": null,
                                    "shirt_number": 50,
                                    "player_position": "Midfielder",
                                    "stats": []
                                },
                                {
                                    "player_id": "blvf8qsi6iy6ejyer58okyxka",
                                    "player_first_name": "Largie",
                                    "player_last_name": "Ramazani",
                                    "player_short_name": "Largie",
                                    "player_dob": "2001-02-27",
                                    "player_birth_place": "Berchem-Sainte-Agathe",
                                    "shirt_number": 17,
                                    "player_position": "Attacker",
                                    "stats": []
                                },
                                {
                                    "player_id": "djo99px7j95m6hzrod3l7yk0l",
                                    "player_first_name": "Daniel",
                                    "player_last_name": "Farke",
                                    "player_short_name": "Daniel",
                                    "player_dob": "1976-10-30",
                                    "player_birth_place": "Steinhausen",
                                    "shirt_number": null,
                                    "player_position": null,
                                    "stats": []
                                },
                                {
                                    "player_id": "cnoomjxp6tna0mx2ycuptgixh",
                                    "player_first_name": "Karl",
                                    "player_last_name": "Darlow",
                                    "player_short_name": "Karl",
                                    "player_dob": "1990-10-08",
                                    "player_birth_place": "Northampton",
                                    "shirt_number": 26,
                                    "player_position": "Goalkeeper",
                                    "stats": []
                                },
                                {
                                    "player_id": "dkwkmrmpb7rq4e660efcu5hat",
                                    "player_first_name": "Daniel Owen",
                                    "player_last_name": "James",
                                    "player_short_name": "Daniel",
                                    "player_dob": "1997-11-10",
                                    "player_birth_place": "Kingston upon Hull",
                                    "shirt_number": 7,
                                    "player_position": "Midfielder",
                                    "stats": []
                                },
                                {
                                    "player_id": "dr0kn3srxtg7nuw99gjoim7e1",
                                    "player_first_name": "Ilia",
                                    "player_last_name": "Iliev Gruev",
                                    "player_short_name": "Ilia",
                                    "player_dob": "2000-05-06",
                                    "player_birth_place": "Sofia",
                                    "shirt_number": 44,
                                    "player_position": "Midfielder",
                                    "stats": []
                                },
                                {
                                    "player_id": "aqlu9i7yzmnmyzwuw6u93j6y1",
                                    "player_first_name": "Noah Arinzechukwu",
                                    "player_last_name": "Okafor",
                                    "player_short_name": "Noah",
                                    "player_dob": "2000-05-24",
                                    "player_birth_place": "Binningen",
                                    "shirt_number": 19,
                                    "player_position": "Attacker",
                                    "stats": []
                                },
                                {
                                    "player_id": "dwumn5qew7ae53givnx2p892h",
                                    "player_first_name": "Jayden Ian",
                                    "player_last_name": "Bogle",
                                    "player_short_name": "Jayden",
                                    "player_dob": "2000-07-27",
                                    "player_birth_place": null,
                                    "shirt_number": 2,
                                    "player_position": "Defender",
                                    "stats": []
                                },
                                {
                                    "player_id": "dx47szytc8vttuj4rcn4yzdre",
                                    "player_first_name": "Isaac",
                                    "player_last_name": "Schmidt",
                                    "player_short_name": "Isaac",
                                    "player_dob": "1999-12-07",
                                    "player_birth_place": "Lausanne",
                                    "shirt_number": 33,
                                    "player_position": "Defender",
                                    "stats": []
                                },
                                {
                                    "player_id": "embn1jhcly07i6pjcvcdiavo5",
                                    "player_first_name": "Lukas Okechukwu",
                                    "player_last_name": "Nmecha",
                                    "player_short_name": "Lukas",
                                    "player_dob": "1998-12-14",
                                    "player_birth_place": "Hamburg",
                                    "shirt_number": 14,
                                    "player_position": "Attacker",
                                    "stats": []
                                },
                                {
                                    "player_id": "f1ma05bi3t1hfbflylx5d9tyh",
                                    "player_first_name": "Ethan Kwame Colm Raymond",
                                    "player_last_name": "Ampadu",
                                    "player_short_name": "Ethan",
                                    "player_dob": "2000-09-14",
                                    "player_birth_place": "Exeter",
                                    "shirt_number": 4,
                                    "player_position": "Defender",
                                    "stats": []
                                },
                                {
                                    "player_id": "fij46jr9fq43444gr1y8tl9l",
                                    "player_first_name": "Gabriel Johan",
                                    "player_last_name": "Gudmundsson",
                                    "player_short_name": "Gabriel",
                                    "player_dob": "1999-04-29",
                                    "player_birth_place": "Malmö",
                                    "shirt_number": 3,
                                    "player_position": "Defender",
                                    "stats": []
                                },
                                {
                                    "player_id": "fr9ac60188vlmtbrcddhxii1",
                                    "player_first_name": "Sebastiaan",
                                    "player_last_name": "Bornauw",
                                    "player_short_name": "Sebastiaan",
                                    "player_dob": "1999-03-22",
                                    "player_birth_place": "Wemmel",
                                    "shirt_number": 23,
                                    "player_position": "Defender",
                                    "stats": []
                                },
                                {
                                    "player_id": "otan631zzfnq2sektkl3ywo9",
                                    "player_first_name": "Joseph Peter",
                                    "player_last_name": "Rodon",
                                    "player_short_name": "Joe",
                                    "player_dob": "1997-10-22",
                                    "player_birth_place": "Swansea",
                                    "shirt_number": 6,
                                    "player_position": "Defender",
                                    "stats": []
                                },
                                {
                                    "player_id": "8rrcscn29rs1gk8mi1pwpu92i",
                                    "player_first_name": "Brenden Russell",
                                    "player_last_name": "Aaronson",
                                    "player_short_name": "Brenden",
                                    "player_dob": "2000-10-22",
                                    "player_birth_place": "Medford",
                                    "shirt_number": 11,
                                    "player_position": "Midfielder",
                                    "stats": []
                                },
                                {
                                    "player_id": "28ucbvor6b0yxreoieehudfc9",
                                    "player_first_name": "Ao",
                                    "player_last_name": "Tanaka",
                                    "player_short_name": "Ao",
                                    "player_dob": "1998-09-10",
                                    "player_birth_place": "Kawasaki",
                                    "shirt_number": 22,
                                    "player_position": "Midfielder",
                                    "stats": []
                                },
                                {
                                    "player_id": "374kcix9j7e1cob4uxmfncwyd",
                                    "player_first_name": "Dominic Nathaniel",
                                    "player_last_name": "Calvert-Lewin",
                                    "player_short_name": "Dominic",
                                    "player_dob": "1997-03-16",
                                    "player_birth_place": "Sheffield",
                                    "shirt_number": 9,
                                    "player_position": "Attacker",
                                    "stats": []
                                },
                                {
                                    "player_id": "6icypdqtfk2k81ax0i49j5xpl",
                                    "player_first_name": "James Michael",
                                    "player_last_name": "Justin",
                                    "player_short_name": "James",
                                    "player_dob": "1998-02-23",
                                    "player_birth_place": "Luton",
                                    "shirt_number": 24,
                                    "player_position": "Defender",
                                    "stats": []
                                },
                                {
                                    "player_id": "6ka58mn83rknx80e4y2jk3949",
                                    "player_first_name": "Joël Mohammed",
                                    "player_last_name": "Ramzan Piroe",
                                    "player_short_name": "Joël",
                                    "player_dob": "1999-08-02",
                                    "player_birth_place": "Wijchen",
                                    "shirt_number": 10,
                                    "player_position": "Attacker",
                                    "stats": []
                                },
                                {
                                    "player_id": "6kih58n0fzlod6c792xpey57t",
                                    "player_first_name": "Jack David",
                                    "player_last_name": "Harrison",
                                    "player_short_name": "Jack",
                                    "player_dob": "1996-11-20",
                                    "player_birth_place": "Stoke-on-Trent",
                                    "shirt_number": 20,
                                    "player_position": "Attacker",
                                    "stats": []
                                },
                                {
                                    "player_id": "6rb8a1xskgyxli8ljn7555yc4",
                                    "player_first_name": "Samuel Nicholas",
                                    "player_last_name": "Chambers",
                                    "player_short_name": "Sam",
                                    "player_dob": "2007-08-18",
                                    "player_birth_place": null,
                                    "shirt_number": 42,
                                    "player_position": "Midfielder",
                                    "stats": []
                                },
                                {
                                    "player_id": "7g5k9i20e02b2og1ucmdakrh0",
                                    "player_first_name": "Harry",
                                    "player_last_name": "Gray",
                                    "player_short_name": "Harry",
                                    "player_dob": "2008-10-08",
                                    "player_birth_place": null,
                                    "shirt_number": 45,
                                    "player_position": "Attacker",
                                    "stats": []
                                },
                                {
                                    "player_id": "7oikovl62nfxs6z54dzd85gx5",
                                    "player_first_name": "Sam",
                                    "player_last_name": "Greenwood",
                                    "player_short_name": "Sam",
                                    "player_dob": "2002-01-26",
                                    "player_birth_place": null,
                                    "shirt_number": null,
                                    "player_position": "Attacker",
                                    "stats": []
                                },
                                {
                                    "player_id": "21mr8cfcc23n2ygrhqqssa579",
                                    "player_first_name": "Alexander Thomas",
                                    "player_last_name": "Cairns",
                                    "player_short_name": "Alex",
                                    "player_dob": "1993-01-04",
                                    "player_birth_place": "Doncaster",
                                    "shirt_number": 21,
                                    "player_position": "Goalkeeper",
                                    "stats": []
                                },
                                {
                                    "player_id": "8szyip8c62bier901hmpqc7vt",
                                    "player_first_name": "Illan Stéphane",
                                    "player_last_name": "Meslier",
                                    "player_short_name": "Illan",
                                    "player_dob": "2000-03-02",
                                    "player_birth_place": "Lorient",
                                    "shirt_number": 16,
                                    "player_position": "Goalkeeper",
                                    "stats": []
                                },
                                {
                                    "player_id": "9drh3w3emxjf6aah8pstsdgr8",
                                    "player_first_name": "Facundo Valentín",
                                    "player_last_name": "Buonanotte",
                                    "player_short_name": "Facundo",
                                    "player_dob": "2004-12-23",
                                    "player_birth_place": "Pérez",
                                    "shirt_number": 40,
                                    "player_position": "Midfielder",
                                    "stats": []
                                },
                                {
                                    "player_id": "9kvp5ddeay1cmfwoao8eo1vbp",
                                    "player_first_name": "Samuel Mark",
                                    "player_last_name": "Byram",
                                    "player_short_name": "Sam",
                                    "player_dob": "1993-09-16",
                                    "player_birth_place": "Thurrock",
                                    "shirt_number": 25,
                                    "player_position": "Defender",
                                    "stats": []
                                },
                                {
                                    "player_id": "9pv566tidfz21e00y4t0mbap5",
                                    "player_first_name": "Sean David",
                                    "player_last_name": "Longstaff",
                                    "player_short_name": "Sean",
                                    "player_dob": "1997-10-30",
                                    "player_birth_place": "Newcastle upon Tyne",
                                    "shirt_number": 8,
                                    "player_position": "Midfielder",
                                    "stats": []
                                },
                                {
                                    "player_id": "9z2j13bl5yh4i1vyofautc9yi",
                                    "player_first_name": "Degnand Wilfried",
                                    "player_last_name": "Gnonto",
                                    "player_short_name": "Wilfried",
                                    "player_dob": "2003-11-05",
                                    "player_birth_place": null,
                                    "shirt_number": 29,
                                    "player_position": "Attacker",
                                    "stats": []
                                },
                                {
                                    "player_id": "a7k01exbkdcshdjzq049ywkq",
                                    "player_first_name": "Darko Boateng",
                                    "player_last_name": "Gyabi",
                                    "player_short_name": "Darko",
                                    "player_dob": "2004-02-18",
                                    "player_birth_place": null,
                                    "shirt_number": null,
                                    "player_position": "Midfielder",
                                    "stats": []
                                },
                                {
                                    "player_id": "ah0f7tonnst92d8q91j1wll62",
                                    "player_first_name": "Jaka",
                                    "player_last_name": "Bijol",
                                    "player_short_name": "Jaka",
                                    "player_dob": "1999-02-05",
                                    "player_birth_place": "Vuzenica",
                                    "shirt_number": 15,
                                    "player_position": "Defender",
                                    "stats": []
                                }
                            ],
                            "staff": [
                                {
                                    "staff_id": "djo99px7j95m6hzrod3l7yk0l",
                                    "staff_first_name": "Daniel",
                                    "staff_last_name": "Farke ",
                                    "staff_short_first_name": "Daniel",
                                    "staff_short_last_name": "Farke",
                                    "staff_title": "manager"
                                }
                            ],
                            "fixture_team_setting": [
                                {
                                    "kit_type": "LEE_H",
                                    "patched": {
                                        "kit_type": true
                                    }
                                }
                            ]
                        }
                    ],
                    "lineup": [
                        {
                            "lineup_id": "1iwz1vv65bg2umetvdwoyvv1l",
                            "official_role": "Assistant referee 1"
                        },
                        {
                            "lineup_id": "d053nf9runthh6h0kpajkh8et",
                            "official_role": "Video Assistant Referee"
                        },
                        {
                            "lineup_id": "aln1gc4kveiqonj82dqhi14ut",
                            "official_role": "Main"
                        },
                        {
                            "lineup_id": "95r6avgfxi2ltwah7s8ac7n4l",
                            "official_role": "Assistant VAR Official"
                        },
                        {
                            "lineup_id": "bozxgffl51xy250whjymv209h",
                            "official_role": "VAR",
                            "patched": {
                                "lineup_id": true,
                                "official_role": true
                            }
                        },
                        {
                            "lineup_id": "e3dovkx10pyggwpgk9bwxllre",
                            "official_role": "Fourth official"
                        },
                        {
                            "lineup_id": "7y43xy7egs94wm5yoo2wjvcnp",
                            "official_role": "Assistant referee 2"
                        }
                    ],
                    "official": [
                        {
                            "official_id": "2jn359tbhejufxtoifjo69k9h",
                            "official_first_name": "Tony",
                            "official_last_name": "Harrington",
                            "official_short_name": "Tony"
                        },
                        {
                            "official_id": "4o97qxyi8weez02gez8nviuad",
                            "official_first_name": "Akil",
                            "official_last_name": "Howson",
                            "official_short_name": "Akil"
                        },
                        {
                            "official_id": "2si0esgp4bc3l7elndz191mfp",
                            "official_first_name": "Nicholas",
                            "official_last_name": "Hopton",
                            "official_short_name": "Nicholas"
                        },
                        {
                            "official_id": "by74g1urvx67zi7hsxcv5nq39",
                            "official_first_name": "Alex",
                            "official_last_name": "Chilowicz",
                            "official_short_name": "Alex"
                        },
                        {
                            "official_id": "36iyqgavkrabmvb4m7mfbwn9x",
                            "official_first_name": "Tom",
                            "official_last_name": "Nield",
                            "official_short_name": "Tom"
                        },
                        {
                            "official_id": "bozxgffl51xy250whjymv209h",
                            "official_first_name": "Paul ",
                            "official_last_name": "Howard",
                            "official_short_name": "Paul"
                        },
                        {
                            "official_id": "8guosclhd3mtyn7lj0s5yhn11",
                            "official_first_name": "Steve",
                            "official_last_name": "Meredith",
                            "official_short_name": "Steven"
                        },
                        {
                            "official_id": "4kgysvo7uxqbbv6qbwoau8lhx",
                            "official_first_name": "Edward",
                            "official_last_name": "Smart",
                            "official_short_name": "Edward"
                        },
                        {
                            "official_id": "ci7ewvcqajfhk34dl5iysl905",
                            "official_first_name": "Andy",
                            "official_last_name": "Madley",
                            "official_short_name": "Andy"
                        },
                        {
                            "official_id": "9fqj6o3vtcziwj0xpzy4e6j85",
                            "official_first_name": "Scott",
                            "official_last_name": "Ledger",
                            "official_short_name": "Scott"
                        },
                        {
                            "official_id": "ays1qinoskgby4otyi5qukg5x",
                            "official_first_name": "Thomas",
                            "official_last_name": "Bramall",
                            "official_short_name": "Thomas"
                        },
                        {
                            "official_id": "4jdwtnqff86ep6hidt8t2r4d1",
                            "official_first_name": "David",
                            "official_last_name": "Webb",
                            "official_short_name": "David"
                        },
                        {
                            "official_id": "cwiylp9viovvrpr70t2vu5brp",
                            "official_first_name": "Steve",
                            "official_last_name": "Martin",
                            "official_short_name": "Steve"
                        },
                        {
                            "official_id": "4tf0xi9z11izspn3f8pugwdlh",
                            "official_first_name": "James",
                            "official_last_name": "Bell",
                            "official_short_name": "James"
                        },
                        {
                            "official_id": "chguyz536296azjg7vtn96xn9",
                            "official_first_name": "Peter",
                            "official_last_name": "Wright",
                            "official_short_name": "Peter"
                        },
                        {
                            "official_id": "2kc5ec54ik00xoyjma7nbior9",
                            "official_first_name": "Simon",
                            "official_last_name": "Long",
                            "official_short_name": "Simon"
                        },
                        {
                            "official_id": "8mj5rcj9n5zdox9318y7wxxp1",
                            "official_first_name": "Stuart",
                            "official_last_name": "Attwell",
                            "official_short_name": "Stuart"
                        },
                        {
                            "official_id": "9fmcv6eoem6aqv7qf6znok72t",
                            "official_first_name": "Mark",
                            "official_last_name": "Scholes",
                            "official_short_name": "Mark"
                        },
                        {
                            "official_id": "d0r3lfwqvsp9efmkwy52i4vyt",
                            "official_first_name": "Natalie",
                            "official_last_name": "Aspinall",
                            "official_short_name": "Natalie"
                        },
                        {
                            "official_id": "6acqyunp7evksdkuduwww0smh",
                            "official_first_name": "Samuel",
                            "official_last_name": "Barrott",
                            "official_short_name": "Samuel"
                        },
                        {
                            "official_id": "e3dovkx10pyggwpgk9bwxllre",
                            "official_first_name": "Farai",
                            "official_last_name": "Hallam",
                            "official_short_name": "Farai"
                        },
                        {
                            "official_id": "468e2tbwkptrdz71k9tgkrn8q",
                            "official_first_name": "Andrew",
                            "official_last_name": "Kitchen",
                            "official_short_name": "Andrew"
                        },
                        {
                            "official_id": "39nr0xjlflwacux3pbd146tey",
                            "official_first_name": "Alistair",
                            "official_last_name": "Nelson",
                            "official_short_name": "Alistair"
                        },
                        {
                            "official_id": "apuulfq3147njhvvcd531u54a",
                            "official_first_name": "Alex",
                            "official_last_name": "James",
                            "official_short_name": "Alex"
                        },
                        {
                            "official_id": "6qwrgq33443z8cnsd9h3g606i",
                            "official_first_name": "Adam",
                            "official_last_name": "Herczeg",
                            "official_short_name": "Adam"
                        },
                        {
                            "official_id": "7j0q0eauq7ho5q2f4zs4lk38q",
                            "official_first_name": "Andrew",
                            "official_last_name": "Dallison",
                            "official_short_name": "Andrew"
                        },
                        {
                            "official_id": "b48kn6oxqgj8ti5yh8yddz7c9",
                            "official_first_name": "Bhupinder",
                            "official_last_name": "Gill",
                            "official_short_name": "Bhupinder"
                        },
                        {
                            "official_id": "4vy0ifnwbezcgm5aydj15lq7d",
                            "official_first_name": "Ruebyn",
                            "official_last_name": "Ricardo",
                            "official_short_name": "Ruebyn"
                        },
                        {
                            "official_id": "6z76n4ptne8u0qbmgy68x2pyh",
                            "official_first_name": "Leigh",
                            "official_last_name": "Doughty",
                            "official_short_name": "Leigh"
                        },
                        {
                            "official_id": "6l853rj271zouu14itxur3cgl",
                            "official_first_name": "John",
                            "official_last_name": "Busby",
                            "official_short_name": "John"
                        },
                        {
                            "official_id": "dyhw9jbfdev4j1c3bmfi104q1",
                            "official_first_name": "Lewis",
                            "official_last_name": "Smith",
                            "official_short_name": "Lewis"
                        },
                        {
                            "official_id": "98p6nbmlnjjtxrqsjbgrzexnt",
                            "official_first_name": "Black",
                            "official_last_name": "Antrobus",
                            "official_short_name": "Blake"
                        },
                        {
                            "official_id": "1iwz1vv65bg2umetvdwoyvv1l",
                            "official_first_name": "Wade",
                            "official_last_name": "Smith",
                            "official_short_name": "Wade"
                        },
                        {
                            "official_id": "7uq2cii93uml3zmjqwvukfe21",
                            "official_first_name": "Samuel",
                            "official_last_name": "Allison",
                            "official_short_name": "Sam"
                        },
                        {
                            "official_id": "8wszpe3f2hj5xi1p9kc0qhyvp",
                            "official_first_name": "Craig",
                            "official_last_name": "Taylor",
                            "official_short_name": "Craig"
                        },
                        {
                            "official_id": "23fcti22no1wt3ohvoe0pd239",
                            "official_first_name": "Thomas",
                            "official_last_name": "Kirk",
                            "official_short_name": "Thomas"
                        },
                        {
                            "official_id": "aa7mx458gag6snx62e5yhgb11",
                            "official_first_name": "Matt",
                            "official_last_name": "Donohue",
                            "official_short_name": "Matt"
                        },
                        {
                            "official_id": "26k89xcleul4a4oh5wbkl09g5",
                            "official_first_name": "Joshua",
                            "official_last_name": "Smith",
                            "official_short_name": "Josh"
                        },
                        {
                            "official_id": "a3d59svrvgs8tjssp1caqtot1",
                            "official_first_name": "Lee",
                            "official_last_name": "Betts",
                            "official_short_name": "Lee"
                        },
                        {
                            "official_id": "49eak7050snf7nxaj3fzdhplh",
                            "official_first_name": "Constantine",
                            "official_last_name": "Hatzidakis",
                            "official_short_name": "Constantine"
                        },
                        {
                            "official_id": "6nefbbdxtp7etu0q6rktroclx",
                            "official_first_name": "Marc",
                            "official_last_name": "Perry",
                            "official_short_name": "Marc"
                        },
                        {
                            "official_id": "e2zgb1da8sj5yduv4k2dl8r85",
                            "official_first_name": "James",
                            "official_last_name": "Mainwaring",
                            "official_short_name": "James"
                        },
                        {
                            "official_id": "3vjf2rwz2imyoslvaole1l1p1",
                            "official_first_name": "Anthony",
                            "official_last_name": "Backhouse",
                            "official_short_name": "Anthony"
                        },
                        {
                            "official_id": "4lzkevhdh926y6u5p9mwxfh05",
                            "official_first_name": "Gavin",
                            "official_last_name": "Ward",
                            "official_short_name": "Gavin"
                        },
                        {
                            "official_id": "95r6avgfxi2ltwah7s8ac7n4l",
                            "official_first_name": "Simon",
                            "official_last_name": "Bennett",
                            "official_short_name": "Simon"
                        },
                        {
                            "official_id": "eh83vbp5w44denpmo9kaaj8ph",
                            "official_first_name": "Richard",
                            "official_last_name": "West ",
                            "official_short_name": "Richard"
                        },
                        {
                            "official_id": "akyyj1yhilv9nfb15b2wb5239",
                            "official_first_name": "Michael",
                            "official_last_name": "Salisbury",
                            "official_short_name": "Salisbury"
                        },
                        {
                            "official_id": "7yp17wkfjfd5ppjdlymqux045",
                            "official_first_name": "Adrian",
                            "official_last_name": "Holmes",
                            "official_short_name": "Adrian"
                        },
                        {
                            "official_id": "c9lhzgx31m1sk0srjcqtq7hzp",
                            "official_first_name": "Daniel",
                            "official_last_name": "Cook",
                            "official_short_name": "Dan"
                        },
                        {
                            "official_id": "a8ron0f4c3q102ue8kjnf7s2d",
                            "official_first_name": "Tim",
                            "official_last_name": "Robinson",
                            "official_short_name": "Tim"
                        },
                        {
                            "official_id": "ajvb57y508k2vzbu0j1j9lf4l",
                            "official_first_name": "Tim",
                            "official_last_name": "Wood",
                            "official_short_name": "Timothy"
                        },
                        {
                            "official_id": "6p8gosb19cf747lf8ih1w3lqt",
                            "official_first_name": "Adam",
                            "official_last_name": "Nunn",
                            "official_short_name": "Adam"
                        },
                        {
                            "official_id": "a2f1uxknjuvoxkhfxofh4u9qt",
                            "official_first_name": "Chris",
                            "official_last_name": "Kavanagh",
                            "official_short_name": "Chris"
                        },
                        {
                            "official_id": "7y43xy7egs94wm5yoo2wjvcnp",
                            "official_first_name": "Nick",
                            "official_last_name": "Greenhalgh",
                            "official_short_name": "Nick"
                        },
                        {
                            "official_id": "cgoeb7me5kff5cxcggsg0p4ut",
                            "official_first_name": "Stuart",
                            "official_last_name": "Burt",
                            "official_short_name": "Stuart"
                        },
                        {
                            "official_id": "3sisydaara6f9jp295fikgafp",
                            "official_first_name": "Gary",
                            "official_last_name": "Beswick",
                            "official_short_name": "Gary"
                        },
                        {
                            "official_id": "6l3ie5htdymg13u2ui69wo251",
                            "official_first_name": "Darren",
                            "official_last_name": "England",
                            "official_short_name": "Darren"
                        },
                        {
                            "official_id": "3pv48ia0bymymidw0t8y8d3v9",
                            "official_first_name": "Dean",
                            "official_last_name": "Whitestone",
                            "official_short_name": "Dean"
                        },
                        {
                            "official_id": "9ystyquhwx9wp6eyayoxmqklx",
                            "official_first_name": "Sian Louise",
                            "official_last_name": "Massey-Ellis",
                            "official_short_name": "Sian"
                        },
                        {
                            "official_id": "cwbtoe7qczmesv50onk6gl1w5",
                            "official_first_name": "Peter",
                            "official_last_name": "Bankes",
                            "official_short_name": "Peter"
                        },
                        {
                            "official_id": "3st0eqq19bhwgt404iy9xrqol",
                            "official_first_name": "Anthony",
                            "official_last_name": "Taylor",
                            "official_short_name": "Anthony"
                        },
                        {
                            "official_id": "4n2p6ko6550c8z2qa4yfdjn4l",
                            "official_first_name": "Michael",
                            "official_last_name": "Oliver",
                            "official_short_name": "Michael"
                        },
                        {
                            "official_id": "4lbq0f8cukafsgqhvjjahb1ed",
                            "official_first_name": "Simon",
                            "official_last_name": "Hooper",
                            "official_short_name": "Simon"
                        },
                        {
                            "official_id": "4jz9tll968c5cscnnxsu8ey8l",
                            "official_first_name": "James",
                            "official_last_name": "Linington",
                            "official_short_name": "James"
                        },
                        {
                            "official_id": "3pn92u0dg8r7z59rio4fmpk9h",
                            "official_first_name": "Oliver",
                            "official_last_name": "Langford",
                            "official_short_name": "Oliver"
                        },
                        {
                            "official_id": "3oe7osb8o3cy0dgex37asng0l",
                            "official_first_name": "Craig",
                            "official_last_name": "Pawson",
                            "official_short_name": "Craig"
                        },
                        {
                            "official_id": "afrtbcmah9i7djl05ptba3i6t",
                            "official_first_name": "Paul",
                            "official_last_name": "Tierney",
                            "official_short_name": "Paul"
                        },
                        {
                            "official_id": "czkuy4mtylpfua7es1sjkqw2d",
                            "official_first_name": "Robert",
                            "official_last_name": "Madley",
                            "official_short_name": "Robert",
                            "patched": {
                                "official_first_name": true
                            }
                        },
                        {
                            "official_id": "d053nf9runthh6h0kpajkh8et",
                            "official_first_name": "John",
                            "official_last_name": "Brooks",
                            "official_short_name": "John"
                        },
                        {
                            "official_id": "c96cf4e3we8zs2sj6wl99zc2d",
                            "official_first_name": "Matthew",
                            "official_last_name": "Wilkes",
                            "official_short_name": "Matt"
                        },
                        {
                            "official_id": "8jfifr4ivvkog68cwper0lqdx",
                            "official_first_name": "Daniel",
                            "official_last_name": "Robathan",
                            "official_short_name": "Dan"
                        },
                        {
                            "official_id": "7cuua8zdmwga3xa653wjdt7md",
                            "official_first_name": "Jarred",
                            "official_last_name": "Gillett",
                            "official_short_name": "Jarred"
                        },
                        {
                            "official_id": "f1g3337l5j65736o54oswmxud",
                            "official_first_name": "Ian",
                            "official_last_name": "Hussin",
                            "official_short_name": "Ian"
                        },
                        {
                            "official_id": "c9ay6ja9ne6d93r5mh4qlkes5",
                            "official_first_name": "Ben",
                            "official_last_name": "Toner",
                            "official_short_name": "Ben"
                        },
                        {
                            "official_id": "eip5zpxbi5gv3r05dv5l2ifh1",
                            "official_first_name": "Neil",
                            "official_last_name": "Davies",
                            "official_short_name": "Neil"
                        },
                        {
                            "official_id": "aln1gc4kveiqonj82dqhi14ut",
                            "official_first_name": "Robert",
                            "official_last_name": "Jones",
                            "official_short_name": "Robert"
                        }
                    ],
                    "venue": [
                        {
                            "venue_id": "3lnmxkrbtsvdffns96nqkggeg",
                            "venue_name": "Stamford Bridge",
                            "venue_city": "London",
                            "venue_country": "England"
                        }
                    ],
                    "stats": [],
                    "event": [
                        {
                            "event_key": "red_card",
                            "event_type": "Card",
                            "event_name": "Red Card",
                            "team_id": "48gk2hpqtsl6p9sx9kjhaydq4",
                            "player1_id": "fij46jr9fq43444gr1y8tl9l",
                            "player2_id": null,
                            "start_x": null,
                            "start_y": null,
                            "start_z": null,
                            "end_x": null,
                            "end_y": null,
                            "end_z": null,
                            "direction": null,
                            "outcome": null,
                            "game_period": "1",
                            "time_in_seconds": 2700
                        },
                        {
                            "event_key": "red_card",
                            "event_type": "Card",
                            "event_name": "Red Card",
                            "team_id": "9q0arba2kbnywth8bkxlhgmdr",
                            "player1_id": "5g5wwp5luxo1rz1kp6chvz0x6",
                            "player2_id": null,
                            "start_x": null,
                            "start_y": null,
                            "start_z": null,
                            "end_x": null,
                            "end_y": null,
                            "end_z": null,
                            "direction": null,
                            "outcome": null,
                            "game_period": "1",
                            "time_in_seconds": 5400
                        },
                        {
                            "event_key": "red_card",
                            "event_type": "Card",
                            "event_name": "Red Card",
                            "team_id": "9q0arba2kbnywth8bkxlhgmdr",
                            "player1_id": "7yirx71oya71zjsgldj5ucqcq",
                            "player2_id": null,
                            "start_x": null,
                            "start_y": null,
                            "start_z": null,
                            "end_x": null,
                            "end_y": null,
                            "end_z": null,
                            "direction": null,
                            "outcome": null,
                            "game_period": "1",
                            "time_in_seconds": 5400
                        },
                        {
                            "event_key": "goal",
                            "event_type": "Goal",
                            "event_name": "Goal",
                            "team_id": "48gk2hpqtsl6p9sx9kjhaydq4",
                            "player1_id": "embn1jhcly07i6pjcvcdiavo5",
                            "player2_id": null,
                            "start_x": null,
                            "start_y": null,
                            "start_z": null,
                            "end_x": null,
                            "end_y": null,
                            "end_z": null,
                            "direction": null,
                            "outcome": null,
                            "game_period": "1",
                            "time_in_seconds": 5400
                        },
                        {
                            "event_key": "goal",
                            "event_type": "Goal",
                            "event_name": "Goal",
                            "team_id": "48gk2hpqtsl6p9sx9kjhaydq4",
                            "player1_id": "fij46jr9fq43444gr1y8tl9l",
                            "player2_id": null,
                            "start_x": null,
                            "start_y": null,
                            "start_z": null,
                            "end_x": null,
                            "end_y": null,
                            "end_z": null,
                            "direction": null,
                            "outcome": null,
                            "game_period": "1",
                            "time_in_seconds": 5400
                        }
                    ]
                }
            ],
                "fixture_result": [
                    {
                        "fixture_id": "3toem7hmu4hjjz4oam9n8tf6c",
                        "competition_id": "2kwbbcootiqqgmrzs6o5inle5",
                        "season_id": "51r6ph2woavlbbpk8f29nynf8",
                        "home_team_score": 2,
                        "away_team_score": 2,
                        "patched": {
                            "home_team_score": true,
                            "away_team_score": true
                        }
                    }
                ]
};

export default plsFootballData;
